module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _c('h2', [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._m(6), _c('a', {
    attrs: {
      "id": "t1"
    }
  }, [_c('big', [_vm._v("1")]), _vm._v(" BUILD A PRO TROUT KIT")], 1)]), _vm._m(7), _c('h2', [_c('a', {
    attrs: {
      "id": "t1"
    }
  }), _vm._m(8), _c('a', {
    attrs: {
      "id": "t2"
    }
  }, [_c('big', [_vm._v("2")]), _vm._v(" SEINE TO MATCH THE HATCH")], 1)]), _vm._m(9), _c('h2', [_c('a', {
    attrs: {
      "id": "t2"
    }
  }), _vm._m(10), _c('a', {
    attrs: {
      "id": "t3"
    }
  }, [_c('big', [_vm._v("3")]), _vm._v(" KNOW WHAT YOU’RE CASTING")], 1)]), _vm._m(11), _c('h2', [_c('a', {
    attrs: {
      "id": "t3"
    }
  }), _vm._m(12), _c('a', {
    attrs: {
      "id": "t4"
    }
  }, [_c('big', [_vm._v("4")]), _vm._v(" DRESS APPROPRIATELY")], 1)]), _vm._m(13), _c('h2', [_vm._m(14), _c('a', {
    attrs: {
      "id": "t5"
    }
  }, [_c('big', [_vm._v("5")]), _vm._v(" BEWARE OF BARGAIN BUGS")], 1)]), _vm._m(15), _c('h2', [_vm._m(16), _c('a', {
    attrs: {
      "id": "t6"
    }
  }, [_c('big', [_vm._v("6")]), _vm._v(" HANDLE TINY FLIES")], 1)]), _vm._m(17), _c('h2', [_c('a', {
    attrs: {
      "id": "t6"
    }
  }), _vm._m(18), _c('a', {
    attrs: {
      "id": "t7"
    }
  }, [_c('big', [_vm._v("7")]), _vm._v(" GET VERSED IN THE MIGHTY MUDDLER MINNOW")], 1)]), _vm._m(19), _c('h2', [_c('a', {
    attrs: {
      "id": "t7"
    }
  }), _vm._m(20), _c('a', {
    attrs: {
      "id": "t8"
    }
  }, [_c('big', [_vm._v("8")]), _vm._v(" MOD YOUR MUDDLER (AND MORE)")], 1)]), _vm._m(21), _c('h2', [_vm._m(22), _c('a', {
    attrs: {
      "id": "t9"
    }
  }, [_c('big', [_vm._v("9")]), _vm._v(" MAKE A DRY RUN")], 1)]), _vm._m(23), _vm._m(24), _vm._m(25), _c('h2', [_c('a', {
    attrs: {
      "id": "e1"
    }
  }), _vm._m(26), _c('a', {
    attrs: {
      "id": "t10"
    }
  }, [_c('big', [_vm._v("10")]), _vm._v(" SAVE YOUR EYES TWO WAYS")], 1)]), _vm._m(27), _c('h2', [_vm._m(28), _c('a', {
    attrs: {
      "id": "t11"
    }
  }, [_c('big', [_vm._v("11")]), _vm._v(" GET THE LIGHT STUFF")], 1)]), _vm._m(29), _c('h2', [_vm._m(30), _c('a', {
    attrs: {
      "id": "t12"
    }
  }, [_c('big', [_vm._v("12")]), _vm._v(" STRING ’EM UP")], 1)]), _vm._m(31), _c('h2', [_c('a', {
    attrs: {
      "id": "t12"
    }
  }), _vm._m(32), _c('a', {
    attrs: {
      "id": "t13"
    }
  }, [_c('big', [_vm._v("13")]), _vm._v(" MIND YOUR GRIP")], 1)]), _vm._m(33), _c('h2', [_c('a', {
    attrs: {
      "id": "t13"
    }
  }), _vm._m(34), _c('a', {
    attrs: {
      "id": "t14"
    }
  }, [_c('big', [_vm._v("14")]), _vm._v(" PLAY WITH FATAL ATTRACTION")], 1)]), _vm._m(35), _vm._m(36), _vm._m(37), _c('h2', [_c('a', {
    attrs: {
      "id": "e2"
    }
  }), _vm._m(38), _c('a', {
    attrs: {
      "id": "t15"
    }
  }, [_c('big', [_vm._v("15")]), _vm._v(" MINT A MINI FLY BOX")], 1)]), _vm._m(39), _c('h2', [_vm._m(40), _c('a', {
    attrs: {
      "id": "t16"
    }
  }, [_c('big', [_vm._v("16")]), _vm._v(" FLOAT BIG WHEN THE GOING’S TOUGH")], 1)]), _vm._m(41), _c('h2', [_c('a', {
    attrs: {
      "id": "t16"
    }
  }), _vm._m(42), _c('a', {
    attrs: {
      "id": "t17"
    }
  }, [_c('big', [_vm._v("17")]), _vm._v(" CHECK YOUR ROD SPEED")], 1)]), _vm._m(43), _c('h2', [_vm._m(44), _c('a', {
    attrs: {
      "id": "t18"
    }
  }, [_c('big', [_vm._v("18")]), _vm._v(" AVOID GETTING LOST")], 1)]), _vm._m(45), _c('h2', [_c('a', {
    attrs: {
      "id": "t18"
    }
  }), _vm._m(46), _c('a', {
    attrs: {
      "id": "t19"
    }
  }, [_c('big', [_vm._v("19")]), _vm._v(" GET A BEAD ON THE BIG BUGS")], 1)]), _vm._m(47), _c('h2', [_c('a', {
    attrs: {
      "id": "t19"
    }
  }), _vm._m(48), _c('a', {
    attrs: {
      "id": "t20"
    }
  }, [_c('big', [_vm._v("20")]), _vm._v(" DIP SOME RUBBER")], 1)]), _vm._m(49), _c('h2', [_c('a', {
    attrs: {
      "id": "t20"
    }
  }), _vm._m(50), _c('a', {
    attrs: {
      "id": "t21"
    }
  }, [_c('big', [_vm._v("21")]), _vm._v(" ANTE UP WITH ANTS")], 1)]), _vm._m(51), _c('h2', [_vm._m(52), _c('a', {
    attrs: {
      "id": "t22"
    }
  }, [_c('big', [_vm._v("22")]), _vm._v(" GET THE DIRT ON HOPPERS")], 1)]), _vm._m(53), _c('h2', [_c('a', {
    attrs: {
      "id": "t22"
    }
  }), _vm._m(54), _c('a', {
    attrs: {
      "id": "t23"
    }
  }, [_c('big', [_vm._v("23")]), _vm._v(" LET YOUR BUGS BREATHE")], 1)]), _vm._m(55), _vm._m(56), _vm._m(57), _c('h2', [_c('a', {
    attrs: {
      "id": "e3"
    }
  }), _vm._m(58), _c('a', {
    attrs: {
      "id": "t24"
    }
  }, [_c('big', [_vm._v("24")]), _vm._v(" TACKLE TOOTHY FISH")], 1)]), _vm._m(59), _c('h2', [_c('a', {
    attrs: {
      "id": "t24"
    }
  }), _vm._m(60), _c('a', {
    attrs: {
      "id": "t25"
    }
  }, [_c('big', [_vm._v("25")]), _vm._v(" PICK A COLD REMEDY")], 1)]), _vm._m(61), _c('h2', [_vm._m(62), _c('a', {
    attrs: {
      "id": "t26"
    }
  }, [_c('big', [_vm._v("26")]), _vm._v(" GET STEAMY")], 1)]), _vm._m(63), _c('h2', [_vm._m(64), _c('a', {
    attrs: {
      "id": "t27"
    }
  }, [_c('big', [_vm._v("27")]), _vm._v(" EGG STEELHEAD ON")], 1)]), _vm._m(65), _c('h2', [_c('a', {
    attrs: {
      "id": "t27"
    }
  }), _vm._m(66), _c('a', {
    attrs: {
      "id": "t28"
    }
  }, [_c('big', [_vm._v("28")]), _vm._v(" MATCHBOOK YOUR MIDGES")], 1)]), _vm._m(67), _c('h2', [_c('a', {
    attrs: {
      "id": "t28"
    }
  }), _vm._m(68), _c('a', {
    attrs: {
      "id": "t29"
    }
  }, [_c('big', [_vm._v("29")]), _vm._v(" GET CRABBY IN WINTER")], 1)]), _vm._m(69), _c('h2', [_c('a', {
    attrs: {
      "id": "t29"
    }
  }), _vm._m(70), _c('a', {
    attrs: {
      "id": "t30"
    }
  }, [_c('big', [_vm._v("30")]), _vm._v(" MAKE LIKE BIGFOOT TO STAY WARM")], 1)]), _vm._m(71), _c('h2', [_vm._m(72), _c('a', {
    attrs: {
      "id": "t31"
    }
  }, [_c('big', [_vm._v("31")]), _vm._v(" WADE OVER TO THE HOCKEY SECTION")], 1)]), _vm._m(73), _c('h2', [_c('a', {
    attrs: {
      "id": "t31"
    }
  }), _vm._m(74), _c('a', {
    attrs: {
      "id": "t32"
    }
  }, [_c('big', [_vm._v("32")]), _vm._v(" JOIN THE BASS BUG REVOLUTION")], 1)]), _vm._m(75), _c('h2', [_c('a', {
    attrs: {
      "id": "t32"
    }
  }), _vm._m(76), _c('a', {
    attrs: {
      "id": "t33"
    }
  }, [_c('big', [_vm._v("33")]), _vm._v(" THROW THE NEW BASS CLASSICS")], 1)]), _vm._m(77), _c('h2', [_vm._m(78), _c('a', {
    attrs: {
      "id": "t34"
    }
  }, [_c('big', [_vm._v("34")]), _vm._v(" FISH LUREINSPIRED FLIES")], 1)]), _vm._m(79), _c('h2', [_c('a', {
    attrs: {
      "id": "t34"
    }
  }), _vm._m(80), _c('a', {
    attrs: {
      "id": "t35"
    }
  }, [_c('big', [_vm._v("35")]), _vm._v(" CARRY EVERYTHING YOU NEED AROUND YOUR NECK")], 1)]), _vm._m(81), _c('h2', [_c('a', {
    attrs: {
      "id": "t35"
    }
  }), _vm._m(82), _c('a', {
    attrs: {
      "id": "t36"
    }
  }, [_c('big', [_vm._v("36")]), _vm._v(" DUNK SOME WOOL")], 1)]), _vm._m(83), _c('h2', [_vm._m(84), _c('a', {
    attrs: {
      "id": "t37"
    }
  }, [_c('big', [_vm._v("37")]), _vm._v(" PAINT IT BLACK")], 1)]), _vm._m(85), _c('h2', [_vm._m(86), _c('a', {
    attrs: {
      "id": "t38"
    }
  }, [_c('big', [_vm._v("38")]), _vm._v(" GO WEEDLESS")], 1)]), _vm._m(87), _c('h2', [_c('a', {
    attrs: {
      "id": "t38"
    }
  }), _vm._m(88), _c('a', {
    attrs: {
      "id": "t39"
    }
  }, [_c('big', [_vm._v("39")]), _vm._v(" PLAY THE ULTRAVIOLET CARD")], 1)]), _vm._m(89), _c('h2', [_vm._m(90), _c('a', {
    attrs: {
      "id": "t40"
    }
  }, [_c('big', [_vm._v("40")]), _vm._v(" STOCK THE EXTRAS")], 1)]), _vm._m(91), _c('h2', [_c('a', {
    attrs: {
      "id": "t40"
    }
  }), _vm._m(92), _c('a', {
    attrs: {
      "id": "t41"
    }
  }, [_c('big', [_vm._v("41")]), _vm._v(" BUILD A THROWBACK FLY BOX")], 1)]), _vm._m(93), _c('h2', [_vm._m(94), _c('a', {
    attrs: {
      "id": "t42"
    }
  }, [_c('big', [_vm._v("42")]), _vm._v(" CHECK THE AIRWAYS")], 1)]), _vm._m(95), _vm._m(96), _vm._m(97), _c('h2', [_c('a', {
    attrs: {
      "id": "e4"
    }
  }), _vm._m(98), _c('a', {
    attrs: {
      "id": "t43"
    }
  }, [_c('big', [_vm._v("43")]), _vm._v(" WAX ON")], 1)]), _vm._m(99), _c('h2', [_vm._m(100), _c('a', {
    attrs: {
      "id": "t44"
    }
  }, [_c('big', [_vm._v("44")]), _vm._v(" REPAIR WADERS IN THE FIELD")], 1)]), _vm._m(101), _c('h2', [_c('a', {
    attrs: {
      "id": "t44"
    }
  }), _vm._m(102), _c('a', {
    attrs: {
      "id": "t45"
    }
  }, [_c('big', [_vm._v("45")]), _vm._v(" SPIKE IT")], 1)]), _vm._m(103), _c('h2', [_vm._m(104), _c('a', {
    attrs: {
      "id": "t46"
    }
  }, [_c('big', [_vm._v("46")]), _vm._v(" FIND A HOLE WITH ALCOHOL")], 1)]), _vm._m(105), _c('h2', [_vm._m(106), _c('a', {
    attrs: {
      "id": "t47"
    }
  }, [_c('big', [_vm._v("47")]), _vm._v(" ROTECT YOUR\nBOOTLACES")], 1)]), _vm._m(107), _c('h2', [_vm._m(108), _c('a', {
    attrs: {
      "id": "t48"
    }
  }, [_c('big', [_vm._v("48")]), _vm._v(" GET WIRED (OR NOT)")], 1)]), _vm._m(109), _c('h2', [_c('a', {
    attrs: {
      "id": "t48"
    }
  }), _vm._m(110), _c('a', {
    attrs: {
      "id": "t49"
    }
  }, [_c('big', [_vm._v("49")]), _vm._v(" GET IN LINE")], 1)]), _vm._m(111), _vm._m(112), _vm._m(113), _c('h2', [_c('a', {
    attrs: {
      "id": "page43"
    }
  }), _vm._m(114), _c('a', {
    attrs: {
      "id": "t50"
    }
  }, [_c('big', [_vm._v("50")]), _vm._v(" TAKE THE LEAD")], 1)]), _vm._m(115), _vm._m(116), _vm._m(117), _c('h2', [_c('a', {
    attrs: {
      "id": "e5"
    }
  }), _vm._m(118), _c('a', {
    attrs: {
      "id": "t51"
    }
  }, [_c('big', [_vm._v("51")]), _vm._v(" CHECK YOUR LEADER")], 1)]), _vm._m(119), _c('h2', [_vm._m(120), _c('a', {
    attrs: {
      "id": "t52"
    }
  }, [_c('big', [_vm._v("52")]), _vm._v(" CHANGE ON THE FLY")], 1)]), _vm._m(121), _c('h2', [_c('a', {
    attrs: {
      "id": "t52"
    }
  }), _vm._m(122), _c('a', {
    attrs: {
      "id": "t53"
    }
  }, [_c('big', [_vm._v("53")]), _vm._v(" HIT THE BAR BEFORE YOU STRIP")], 1)]), _vm._m(123), _vm._m(124), _vm._m(125), _c('h2', [_c('a', {
    attrs: {
      "id": "e6"
    }
  }), _vm._m(126), _c('a', {
    attrs: {
      "id": "t54"
    }
  }, [_c('big', [_vm._v("54")]), _vm._v(" DUCK TANGLED LINES")], 1)]), _vm._m(127), _c('h2', [_vm._m(128), _c('a', {
    attrs: {
      "id": "t55"
    }
  }, [_c('big', [_vm._v("55")]), _vm._v(" REDUCE FLY-LINE MEMORY WITH A COFFEE CAN")], 1)]), _vm._m(129), _c('h2', [_c('a', {
    attrs: {
      "id": "t55"
    }
  }), _vm._m(130), _c('a', {
    attrs: {
      "id": "t56"
    }
  }, [_c('big', [_vm._v("56")]), _vm._v(" UNDERSTAND YOUR FLY REEL")], 1)]), _vm._m(131), _c('h2', [_c('a', {
    attrs: {
      "id": "t56"
    }
  }), _vm._m(132), _c('a', {
    attrs: {
      "id": "t57"
    }
  }, [_c('big', [_vm._v("57")]), _vm._v(" GET THE INSIDE SCOOP ON FLY REELS")], 1)]), _vm._m(133), _vm._m(134), _vm._m(135), _c('h2', [_c('a', {
    attrs: {
      "id": "e7"
    }
  }), _vm._m(136), _c('a', {
    attrs: {
      "id": "t58"
    }
  }, [_c('big', [_vm._v("58")]), _vm._v(" FIX YOUR HOLY CORK")], 1)]), _vm._m(137), _c('h2', [_vm._m(138), _c('a', {
    attrs: {
      "id": "t59"
    }
  }, [_c('big', [_vm._v("59")]), _vm._v(" CRAFT A MAKESHIFT MINI CASTER")], 1)]), _vm._m(139), _c('h2', [_c('a', {
    attrs: {
      "id": "t59"
    }
  }), _vm._m(140), _c('a', {
    attrs: {
      "id": "t60"
    }
  }, [_c('big', [_vm._v("60")]), _vm._v(" PERFORM EMERGENCY GUIDE REPAIRS")], 1)]), _vm._m(141), _c('h2', [_vm._m(142), _c('a', {
    attrs: {
      "id": "t61"
    }
  }, [_c('big', [_vm._v("61")]), _vm._v(" GET GREASY WHEN IT’S COLD")], 1)]), _vm._m(143), _vm._m(144), _c('a', {
    attrs: {
      "id": "e8"
    }
  }), _c('h2', [_c('a', {
    attrs: {
      "id": "e8"
    }
  }), _vm._m(145), _c('a', {
    attrs: {
      "id": "t62"
    }
  }, [_c('big', [_vm._v("62")]), _vm._v(" GO FIBERGLASS FIRST")], 1)]), _vm._m(146), _c('h2', [_vm._m(147), _c('a', {
    attrs: {
      "id": "t63"
    }
  }, [_c('big', [_vm._v("63")]), _vm._v(" TAKE CARE OF YOUR GUIDES")], 1)]), _vm._m(148), _c('h2', [_c('a', {
    attrs: {
      "id": "t63"
    }
  }), _vm._m(149), _c('a', {
    attrs: {
      "id": "t64"
    }
  }, [_c('big', [_vm._v("64")]), _vm._v(" TRY A CANE ROD")], 1)]), _vm._m(150), _vm._m(151), _vm._m(152), _c('h2', [_c('a', {
    attrs: {
      "id": "e9"
    }
  }), _vm._m(153), _c('a', {
    attrs: {
      "id": "t65"
    }
  }, [_c('big'), _vm._v("65 TURN JAPANESE WITH TENKARA")], 1)]), _vm._m(154), _c('h2', [_c('a', {
    attrs: {
      "id": "t65"
    }
  }), _vm._m(155), _c('a', {
    attrs: {
      "id": "t66"
    }
  }, [_c('big', [_vm._v("66")]), _vm._v(" MAKE A POOR MAN’S CASE")], 1)]), _vm._m(156), _c('h2', [_vm._m(157), _c('a', {
    attrs: {
      "id": "t67"
    }
  }, [_c('big', [_vm._v("67")]), _vm._v(" CAST, DON’T WIGGLE")], 1)]), _vm._m(158), _c('h2', [_c('a', {
    attrs: {
      "id": "t67"
    }
  }), _vm._m(159), _c('a', {
    attrs: {
      "id": "t68"
    }
  }, [_c('big', [_vm._v("68")]), _vm._v(" STORE GEAR FOR A WINTER’S NAP")], 1)]), _vm._m(160), _c('h2', [_c('a', {
    attrs: {
      "id": "t68"
    }
  }), _vm._m(161), _c('a', {
    attrs: {
      "id": "t69"
    }
  }, [_c('big', [_vm._v("69")]), _vm._v(" PACK FOR YOUR FLIGHT")], 1)]), _vm._m(162), _vm._m(163), _vm._v(" "), _vm._m(164), _vm._v(" "), _vm._m(165), _vm._v(" "), _vm._m(166), _vm._v(" "), _vm._m(167)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p10-11.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "start1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p13.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OF ALL THE FLY SHOPS I’VE VISITED")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("over the years, none has stuck with me more than Trout Brook Fly Shop in Trout Brook, New Brunswick, Canada. It’s just a tiny shack off a quiet country road in the middle of nowhere that caters to local Atlantic salmon fishermen. The folks who own Trout Brook don’t stock flasks, T-shirts, reels worth a thousand dollars, or titanium nippers. They have only what you need. Their 50-dollar reels will land salmon just fine, and their 99-cent nippers will cut your line perfectly. They do, however, have an exceptional assortment of hand-tied salmon flies and, even more important, years of tips and tricks to share about getting finicky Atlantics to hit those flies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My hope is that your take-away from this chapter matches what I took from Trout Brook: a clear understanding of what you need to be effective on the water without all the “add-on sales.” Here you will find the basic breakdowns of the gear that matters most, backed up with insider tips, tricks, and tweaks to get the most out of all your equipment—your rod, your net, your flies, and even the soles of your wading boots.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p14a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Flyfishing guide Pat Dorsey is a hot-stick guide on some of America’s toughest trout waters. Over the years, he’s gotten gear organization down to a science. Here, he shares the stuff that he can’t fish without.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sa.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("MULTITOOL")]), _vm._v(" The Tie-Fast knot-tying multitool is always handy and speeds the knot-tying process.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sb.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("NIPPERS & HEMOS")]), _vm._v(" These are the tools he uses most. Absolutely essential.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sc.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("TIPPETS & LEADERS")]), _vm._v(" Dorsey uses mono Rio Powerflex leaders, sizes 2X through 6X, and organizes them in a Rio Leader Wallet. He separates his spools of mono and fluoro tippet onto two Tippet-T holders. “I use mono 80 percent of the time, and save the fluoro for clear water and really spooky fish,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sd.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("STRIKE INDICATORS")]), _vm._v(" Here is a Dorsey hallmark: He makes his indicators from Holly Twist brown craft yarn—pre-cut in 1½-inch strips—that he gets at a crafts store. He fastens the yarn to leaders with orthodontic rubber bands. “Yarn is most sensitive in detecting strikes,” Dorsey says.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/se.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("SHARPENER")]), _vm._v(" “Too many anglers fish with dull hooks and wonder why they don’t catch more trout. I check my hook points when I tie on any fly.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sf.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("FLUFFING TOOL")]), _vm._v(" To fluff out the yarn of his indicators, Dorsey carries this homemade tool. To make one, wrap a strip of Velcro tape (the “teeth” half) around one end of a wooden dowel. Fluff the yarn by brushing it with the Velcro.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sg.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("HEADLAMP")]), _vm._v(" “Not many other guides I know carry a headlamp, but I don’t ever want to be caught hiking out of a dark canyon or trying to fish an evening hatch without one.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sh.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("WEIGHT")]), _vm._v(" Dorsey carries two types of sinkers: Mojo Mud, a soft tungsten-based weight; and Orvis nontoxic split shot. “I use split shot as a base, and then form Mojo Mud around it. I can add or remove Mojo Mud to adjust my nymph rig weight from run to run, which is important because I’ll change weight a few times before I even think about switching flies.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/si.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("STOMACH PUMP")]), _vm._v(" “Sometimes it pays to discover what the trout are actually eating,” Dorsey says of this handy tool. “You might hook a fish on a midge fly but discover they’re also eating mayfly nymphs. The pump has often led me to switch fly patterns.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sj.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("SUN PROTECTION")]), _vm._v(" Dorsey is never without Simms lip balm, 50-SPF sunscreen, and Off! bug spray.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sk.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("FLY BOXES")]), _vm._v(" Dorsey organizes his dry-fly boxes by hatch, and arranges his nymphs in rows by theme: small tailwater flies, beadheads, attractor nymphs, and so on. “Being organized with your flies is critical,” Dorsey says. “Most people have the stuff they need. They just don’t know how to find it.”")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t2"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Instead of grabbing a fly and hoping that you’re close, get some inside information by seining a stream before you fish it. First, wade out to where fish typically hold. Firmly grasp a small hand seine downstream from your feet on the creekbottom and turn over a dozen rocks or so. Bring up the net and look closely. Also check the surface flow in the current below if fish are actively feeding around you. You should pick up hatching insects, as well as any terrestrials that have the fish turned on. You don’t have to be an entomologist to figure out how to match what you seine.")]), _vm._v(" "), _c('div', {
    staticClass: "box_border"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAYFLY NYMPHS")]), _vm._v(" come in many forms, depending on the particular species: crawling, swimming, or burrowing. Try to match the general size, color, and profile of the insect.")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15a.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box_border"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STONEFLY NYMPHS")]), _vm._v(" are often large and can’t swim, so they must crawl from stream bottoms to dry land or overhanging vegetation to emerge. Trout gorge on them. Match color and size.")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15b.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box_border"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CADDISFLY NYMPHS")]), _vm._v(" have two aquatic life stages. The larva lives in a tiny tube made of twigs and sand grains. It then seals itself into a case to pupate and grow legs and wing pads before emerging.")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15c.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p16.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are hundreds of thousand of trout flies on the market, and the specific pattern you need to hook up will change from season to season and region to region. But before diving into the details, it’s important to first have a basic understanding of common fly styles so you know what they represent and when to put them in play on the river.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sa.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("STREAMERS")]), _vm._v(" These big flies represent large forage like small baitfish, leeches, and crayfish. While dry-fly and nymph techniques use the current to impart natural action to the flies, streamers require the angler to work them with the rod and line to bring them to life. Cast one just above a likely trout hiding spot, and strip the streamer back with pops and pauses as it moves with the current. Quite often, the more frantic and erratic you make the fly’s swimming, the more strikes it draws. Many streamers have weighted cores or heads to help them get down faster in moving water, but depending on the depth, hardcore streamer junkies often lean on sink-tip lines to up their drop rate even more. Regardless of what streamer pattern you buy, it’s smart to grab some in white, black, and bright chartreuse. Use white on sunny days, black on overcast days, and the bright colors when the water’s stained.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sb.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("NYMPHS")]), _vm._v(" Nymphs represent aquatic insects in their larval stage, during which they live on the bottom of rivers and lakes before moving to the surface and hatching into adults. How you fish nymphs will depend largely on water speed and depth. As they don’t float on the surface, you commonly drift nymphs with a few lead split shot crimped to the leader to get them ticking over the bottom. However, in shallow water, you can fish nymphs with no added weight. You can also go weightless when trying to represent an emerging insect, which would be rising in the water column. To create this illusion, cast a nymph upstream, mend your line to help it sink, and then let it swing tight as it rides the current. If you are fishing nymphs close to the bottom, a strike indicator connected to the top end of your leader and floating on the surface can help you detect subtle bites. If the indicator stutters as it drifts, set the hook. Like dry flies, nymphs are available in nearly endless patterns, but having an array of basic nymph colors is often more useful than a variety of sizes. If you have nymphs in tan, black, and olive, you’re usually all set for any situation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sc.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("DRY FLIES")]), _vm._v(" Dry flies represent adult aquatic insects. As the name suggests, these patterns float on the surface and prompt feeding trout to rise for the take, resulting in some of the most memorable eats you’ll ever experience on the water. Flyfishing as a sport is rooted in the use of dry flies. They were the beginning from which new tactics and fly styles evolved. Dries come in a huge range of sizes, and fly size is arguably the most important element when choosing one of these bugs. Suppose you’re watching trout rise to sulfurs, which are pale yellow. In your box you have dries that match the color but are larger than the live bugs. You also have flies that are gray but match the size perfectly. The fish are likely to hit the size match before they go for the color match. Most of the time, this rule will keep the line tight even when you don’t have the perfect representation of the hatching bugs.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Drifting a dry fly is all about creating a natural presentation. Most of that comes from your ability to cast in the right feeding lane and manage your line so the fly never drags. But having a fly that looks as good as possible and floats high doesn’t hurt either. Here’s how to dress your dries for maximum success.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/s1.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("PREP YOUR FLY")]), _vm._v(" Before you tie on your fly pattern, use a toothpick (or another pointed object) to tease the wings and tail into shape—spread out the hackle fibers and separate the wings. Clip off any loose threads or feathers, check the sharpness of your hook, and bend down the barb if you plan to catch and release.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/s2.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("USE FLOATANT")]), _vm._v(" Work a bit of liquid floatant between your fingers, and then massage just enough on the fly to darken the fur and feathers. Next, re-tease the wings and tail with your toothpick. Coating foam-bodied flies, such as Chernobyl Ants, in liquid floatant works, but you will want to air-dry the bug before that first cast.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/s3.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("MAINTAIN THE DRESSING")]), _vm._v(" If the fly drowns in the current or gets eaten by a trout, use a powder floatant to wick away moisture and recondition the materials. No-hackle patterns and those with CDC accents don’t benefit from liquids and greases. Simply shake the fly before fishing it.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17c.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t5"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lots of online retailers these days sell flies by the dozen for cheap—but consider that super-cheap flies are often tied on super-cheap hooks. And when the trout of a lifetime straightens the hook of your tiny discount dry fly, you’ll wish you had spent a few dollars more for a quality bug.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17d.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t5"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("To hold small flies that you’re tying onto fine-diameter leaders, use an X-Acto hobby knife handle, which is about the size of a ballpoint pen. Insert the barb into the jaws, where the blade would go, and tighten.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t7"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If I’m asked to name the most versatile fly ever tied, it’s an easy choice: the Muddler Minnow. You can fish this fly (and its cousins) several ways, and it imitates a wide range of things trout love to eat. Greased up, it floats like a grasshopper. Stripped through deep pools, it resembles a juicy sculpin. Skated at night, it’s a mouse. The more creative you are, the more you appreciate this classic.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TOP SPIN")]), _vm._v(" The more densely spun and tightly clipped the deer hair, the more buoyant the Muddler, and the more water it displaces when ripped below the surface as a streamer.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ORIGINAL RECIPE")]), _vm._v(" The typical Muddler features a spun deer- hair head, a turkey feather underwing and tail, and a tinsel-wrapped body.")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are plenty of variants. The original Gapen Muddler (A), created in 1937 by Don Gapen, has a sparser head section and is ideal for clear sculpin-laden waters. A Marabou Muddler (B) has a softer marabou underwing, which pulsates in the water; it’s a solid leech imitation when dead-drifted. The weighted Tunghead Muddler (C) dives quickly. Fish it by swinging it through swift currents, or dredge it through deep pools The Black Muddler (D) is best for tinted water, in low-light, or on the surface as a cicada or cricket mimic.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p19.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Another great thing about the Muddler Minnow is that with its multiple personalities, you can fish it in different ways to cover a variety of situations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Its primary role is that of a streamer. Pulled below the surface, it looks like a sculpin or other baitfish. If you grease the deer hair on a Muddler, however, and either dead-drift it on the surface or twitch it slightly under a cutbank, it looks a lot like a grasshopper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Muddler offers a prime example of the fact that all flies can assume very different traits if an angler understands how to adapt its presentations. Clip the wings and hackles on an Adams dry fly, for example, and you’ve just made an RS2 emerger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The point is to adapt your flies to different situations. You don’t need to use 50 patterns for 50 scenarios. You’re better off with 10 flies, knowing how to fish each one five different ways.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p19a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t8"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t9"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although waders and wading boots are designed to get wet, that doesn’t mean water can’t do long-term damage to them. When a trip is over, proper drying of boots and waders is critical for many reasons. Prolonged dampness breeds bacteria that can cause boots and waders to smell pretty gamey. It can also foster mold growth, which over time can cause these items to deteriorate. Though it might seem counterintuitive, you should turn waders inside out and hang them to dry. This helps any interior moisture from sweat or pinhole leaks evaporate. After they’ve dried inside out for a day, reverse them and let the exterior dry. If you store wet boots in a dank basement or garage, they probably won’t dry as quickly as they should. Leave them outside, preferably in a sunny spot, where they can get plenty of air circulation. If you’ve got a heated garage or basement, however, they may actually dry faster close to the heat source than they would outside, especially during colder times of year.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_border"
  }, [_c('a', {
    attrs: {
      "id": "t9"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p19b.jpg"
    }
  })])]), _c('div', {
    staticClass: "boxa"
  }, [_c('a', {
    attrs: {
      "id": "t9"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "t9"
    }
  }), _c('a', {
    attrs: {
      "id": "e1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIAL FLIES: PARACHUTE ADAMS")])])]), _c('a', {
    attrs: {
      "id": "e1"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYPE:")]), _vm._v(" Dry Fly")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIMARY SPECIES:")]), _vm._v(" Trout")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Most dry flies mimic a specific bug; the Adams represents absolutely nothing in particular and is one of the most—if not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the")]), _vm._v(" most—potent dry flies ever tied. When in doubt, or if you can’t decipher exactly what bug is drifting on the surface, try an Adams. Its neutral colors and generic profile make the play more often than not, provided you match the live bug’s size. It is available with multiple wing types, but the parachute wing is the most buoyant and easiest for the angler to see during the drift.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "e1"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t10"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Not only are polarized sunglasses one of the most important tools for fly casting because they help you spot fish, discern depth, and pick out bottom structure; they protect your eyes. If you’re whipping a fly through the air, it doesn’t take much more than a little gust of wind to botch a cast and send a bug screaming at your face. That fly could be tied to your buddy’s line, or just as easily to yours during a solo outing. If you’re flyfishing, your sunglasses should stay on regardless of the weather or light conditions. In low light, try yellow lenses. I’ve learned this the hard way, as you can see in the photo.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t10"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t11"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A headlamp is a must for nighttime trout hunters, and lens color is key. Here’s what to use when… if ever.")]), _vm._v(" "), _c('div', {
    staticClass: "box_border"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("GREEN LENS COLOR")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ALWAYS")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Great for tying knots, won’t hurt your night vision, and won’t spook fish")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/2.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("RED LENS COLOR")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SOMETIMES")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("O.K. for tying knots up close, but won’t light anything more than a few feet away.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/3.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("WHITE LENS COLOR")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NEVER")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("It’s the brightest, but it will hamper your night vision and scare fish.")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20b.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t11"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Looking for a better way to transport fly rods without breaking them down every time you change spots? All you need are two lengths of cheap ¼-inch rope. Connect the ends of one length to the hanger hooks found in the back of most SUVs. You want the rope high enough that it allows you to stow other gear beneath, but don’t pull it too tight. A little slack forces all the heavy butt ends with reels to rest in the middle so that they don’t bounce around. Loop a second shorter length of rope around your rearview mirror. The rope in the back of the truck will cradle the butts, and the small loop in front will hold all the rod tips so they don’t knock against the windshield.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p21.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fly rod blanks are built first and foremost to deliver anglers the best possible cast based on line and fly weight. What they’re "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" typically designed for is winching a fish to the net at warp speed. Unlike spinning and conventional rods with tapers that can accommodate a heavy-handed approach to fighting fish, there is no faster way to break a fly rod than to grip the blank above the cork during a battle. By gripping the rod ahead of the cork, you are moving the rear flex point to a spot not intended to carry that load. Some rods built for large gamefish feature a second “fighting grip” above the handle to provide extra power, but these rods are designed to flex at the fighting grip. If you remember to only grab cork during the fight, you will greatly extended the life of your fly rods.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t14"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Absent an obvious hatch, you want a fly pattern that’s buggy enough to earn interest, gaudy enough to cause a reaction strike, or just plain meaty-looking enough that the trout cannot let it float by. You want an attractor, and it’s hard to beat these four.")]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("THE PATTERN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p22a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rubber Legged Stimulator")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHY IT WORKS")]), _c('br'), _vm._v("This fly replicates a wide range of natural insects, from stoneflies to caddisflies to hoppers.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHEN TO FISH IT")]), _c('br'), _vm._v("Spring through fall, especially midsummer.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HOW TO WORK IT")]), _c('br'), _vm._v("Dead-drift the fly tight to banks. The seductive legs will do the rest.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYING TWEAK")]), _c('br'), _vm._v("In dirty water, increase the flash with a sparkle dubbing body.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("THE PATTERN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p22b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Autumn Splendor")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHY IT WORKS")]), _c('br'), _vm._v("The brown body gives it crayfish appeal, and the rubber legs can drive trout wild.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHEN TO FISH IT")]), _c('br'), _vm._v("It’s not a fall-only pattern. Fish it year-round.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HOW TO WORK IT")]), _c('br'), _vm._v("Bang the banks, and then retrieve the fly with fast, erratic strips.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYING TWEAK")]), _c('br'), _vm._v("Remove the conehead weight for softer presentations to lake fish.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("THE PATTERN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p22c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Twenty Incher")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHY IT WORKS")]), _c('br'), _vm._v("It’s a Prince Nymph on steroids, with soft hackle wing accents that oscillate in the water.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHEN TO FISH IT")]), _c('br'), _vm._v("Year-round, but it’s most deadly in spring and summer.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HOW TO WORK IT")]), _c('br'), _vm._v("Make it the lead fly on a double rig, and dead-drift it through deep runs.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYING TWEAK")]), _c('br'), _vm._v("Mix and match head dubbing colors to find the money mix.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("THE PATTERN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p22d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mercer’s Lemming")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHY IT WORKS")]), _c('br'), _vm._v("No natural food packs more protein power than mice. This imitator signals a big meal for big fish.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHEN TO FISH IT")]), _c('br'), _vm._v("Summer nights when big trout are on the prowl.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HOW TO WORK IT")]), _c('br'), _vm._v("Make short, erratic strips toward the shore, above runs, and around cover.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYING TWEAK")]), _c('br'), _vm._v("Dab a spot of glow-in-thedark paint on the head so you can see it at night.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_border"
  }, [_c('a', {
    attrs: {
      "id": "t14"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p22.jpg"
    }
  })])]), _c('div', {
    staticClass: "boxa"
  }, [_c('a', {
    attrs: {
      "id": "t14"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "t14"
    }
  }), _c('a', {
    attrs: {
      "id": "e2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIAL FLIES: WOOLLY BUGGER")])])]), _c('a', {
    attrs: {
      "id": "e2"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYPE:")]), _vm._v(" Streamer/Nymph")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIMARY SPECIES:")]), _vm._v(" Trout, Bass, Panfish, Carp")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Not only is the Woolly Bugger an easy fly to tie, it’s one of the most versatile in freshwater. Depending on size and color, this fly can represent almost anything. A black one drifting down a smallmouth river is a spot-on hellgrammite copy. Stripped deep and fast, an olive-green bugger will fool brown trout feeding on sculpins. Slow-hop a rusty orange one in front of a carp rooting for crayfish, and it will get slurped. Don’t hit a lake or river without your Woolly Buggers. They’ll score when fish refuse all other flies.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "e2"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t15"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aside from sparing your fishing buddies your early-morning coffee breath, there’s another reason to eat Altoids: The empty tin makes an ideal fly box. And if one of those pals who’s suffered your horrible breath before is new to flyfishing, you can apologize with one of these. It’s the perfect beginner’s fly box.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 1")]), _vm._v(" First clean out the mint dust from the tin. Cut the following from a shoebox: one 3½x ¾-inch strip to fit lengthwise inside the tin, and two 2⅛x ¾-inch strips to fit widthwise.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 2")]), _vm._v(" Cut two notches halfway through the longer strip. Do the same down the center of each shorter strip. Insert those shorter strips into the longer piece at the notches you have made.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 3")]), _vm._v(" Wrap the cardboard with duct tape. The tape strengthens the cardboard, protects it from water damage, and gives the grid a snugger fit inside the tin. If you don’t need compartments, stick sheets of magnet or foam inside the tin.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23d.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t15"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t16"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of the lessons I learned from scuba diving with trout came from watching them react to attractor flies. To set the scene, I had a buddy fishing a two-fly dry-fly rig. The lead fly was a size 12 Stimulator—a big bug that might look like a terrestrial or a stonefly, although its basic mission is to stimulate a rise. The second fly, trailed 18 inches off the bend of the first, was a size 18 Bluewing Olive, meant to match natural Baetis flies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I watched the fish from below the surface, I noticed they’d swim up to check the larger fly, then catch sight of the smaller fly and go eat it. The lesson is that if you are fishing two small dries, you will not draw the fishes’ attention as consistently as you would with an attractor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The attractor fly really works when you are out prospecting and when there isn’t a consistent hatch coming off. When you’re fishing a prolific hatch, don’t mess around with attractors.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p24.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Fast” and “slow” are adjectives you’ll hear often when describing the action of a fly rod. But what do they mean? It’s all about how much or how little a rod flexes when you cast. Here are the advantages of slow and fast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FAST")]), _vm._v(" These days, the majority of fly rods on the market are considered fast, which ultimately means they’re stiff. While that might seem counterproductive, a rod that flexes quickly and more rigidly increases casting distances and actually makes casting easier on the arm. This is especially true when using heavier fly rods for big game, or when casting sink tip lines and weighted flies. Modern graphite rods are also very light. Combine the weight with a fast action, and you have a rod that delivers far and accurately and won’t kill you when you’re casting all day.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SLOW")]), _vm._v(" Before graphite came along, most fly rods were considered slow. That’s because materials such as fiberglass and bamboo were naturally “softer,” and therefore had more flex. These materials also made rods much heavier, but plenty of casters still prefer the action of fiberglass and split cane, especially for delivering bulky flies like deer hair bass bugs. Slow rods can be cast just as accurately as fast rods, but they force you to think a bit more about each stroke and take your time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many casting instructors prefer that beginners learn on slow rods for that very reason. Many anglers also prefer the soft action for hard-fighting fish such as salmon and steelhead, because a mushier rod better absorbs the sudden line jolts that happen when these fish run, theoretically resulting in fewer break-offs.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p24a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t17"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("On a summer evening, you may very well wade-fish a river until after the sun has set and the path back to your vehicle is no longer clear. Bankside brush all looks pretty much the same in darkness; bushwhacking out is too often the result. But the solution is easy: When you first enter the river, tie a white handkerchief or paper towel to a branch to make your return path easy to find. Just be sure to remove the marker as you exit.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t19"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are thousands of hatches that occur across the U.S., many of which involve relatively small bugs. Then there are those special hatches where the insects are monstrous and the trout that rise to them to them are massive. The key to cashing in on these big-trout feeding frenzies is knowing when and where these jumbo bugs are going to show up.")]), _vm._v(" "), _c('div', {
    staticClass: "box_border"
  }, [_c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("COMMON NAME "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Latin Name)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BROWN DRAKE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Ephemera Simulans)")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COLOR")]), _c('br'), _vm._v("Speckled brown")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIZE")]), _c('br'), _vm._v("¾ inch")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HABITAT")]), _c('br'), _vm._v("Silt, fine gravel: riffles and pools")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF YEAR")]), _c('br'), _vm._v("Late spring, early summer")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF DAY")]), _c('br'), _vm._v("Late afternoon, evening")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("REGIONS")]), _c('br'), _vm._v("Midwest, West, East")])]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("ALL-AROUND FLY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25f.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BROWN DRAKE WULFF")])])]), _vm._v(" "), _c('div', {
    staticClass: "box_border"
  }, [_c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("COMMON NAME "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Latin Name)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GREEN DRAKE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Ephemera Guttulata)")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COLOR")]), _c('br'), _vm._v("Green, olive, brown")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIZE")]), _c('br'), _vm._v("1 inch")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HABITAT")]), _c('br'), _vm._v("Silt, fine gravel: riffles and pools")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF YEAR")]), _c('br'), _vm._v("Late spring, early summer")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF DAY")]), _c('br'), _vm._v("Late afternoon, evening")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("REGIONS")]), _c('br'), _vm._v("East, West")])]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("ALL-AROUND FLY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25g.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EXTENDED BODY GREEN DRAKE")])])]), _vm._v(" "), _c('div', {
    staticClass: "box_border"
  }, [_c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("COMMON NAME "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Latin Name)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MICHIGAN CADDIS, HEX")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Hexagina Limbata)")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COLOR")]), _c('br'), _vm._v("Yellow and brown")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIZE")]), _c('br'), _vm._v("1½ inches")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HABITAT")]), _c('br'), _vm._v("Silt: slow water")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF YEAR")]), _c('br'), _vm._v("Early spring, midsummer")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF DAY")]), _c('br'), _vm._v("Evening, twilight, dark")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("REGIONS")]), _c('br'), _vm._v("Midwest, Northeast, Northwest")])]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("ALL-AROUND FLY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25h.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HEXAGENIA")])])]), _vm._v(" "), _c('div', {
    staticClass: "box_border"
  }, [_c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("COMMON NAME "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Latin Name)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GIANT SALMONFLY")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Pteronarcyidae)")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COLOR")]), _c('br'), _vm._v("Salmon-orange body, dark wings")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIZE")]), _c('br'), _vm._v("2½ inches")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HABITAT")]), _c('br'), _vm._v("Rocky, fast water")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF YEAR")]), _c('br'), _vm._v("Late spring, midsummer")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF DAY")]), _c('br'), _vm._v("All day")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("REGIONS")]), _c('br'), _vm._v("West, Midwest, East")])]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("ALL-AROUND FLY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25i.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ROGUE FOAM STONE")])])]), _vm._v(" "), _c('div', {
    staticClass: "box_border"
  }, [_c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("COMMON NAME "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Latin Name)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25e.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GOLDEN STONE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Ephemera Guttulata)")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COLOR")]), _c('br'), _vm._v("Gold and brown")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIZE")]), _c('br'), _vm._v("1½ inches")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HABITAT")]), _c('br'), _vm._v("Rocky, fast water")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF YEAR")]), _c('br'), _vm._v("Late spring, midsummer")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIME OF DAY")]), _c('br'), _vm._v("All day")])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("REGIONS")]), _c('br'), _vm._v("West, Midwest, East")])]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("ALL-AROUND FLY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25j.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("YELLOW STIMULATOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t20"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Studies show that nets with rubber bags are ideal for all species of gamefish. Nylon nets (especially those with knots) and mesh cloth nets have been proven to damage fins and remove a fish’s protective slime coating, leaving it prone to disease and infection until the coating re-forms. Rubber nets are far gentler, which is especially important with the more delicate species such as trout. Over the last few years, rubber “ghost nets” have become very popular. They cause minimal damage to the catch and fishermen also widely believe the translucent color further reduces stress, as it blends better with the water than a traditional black or green bag. As a bonus, flies won’t tangle in a rubber net nearly as easily as they will in a cloth net.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t21"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ants of various types are numerous along the shores of all trout streams. They also fall in the water often, so trout are accustomed to seeing them. The best imitation by far is a simple Fur Ant, which you can fish either dry or wet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Black and cinnamon are common ant colors, and it’s easy to carry both imitations in sizes 10 to 20. Fishing slow water behind a logjam might call for a size 10 to imitate the larger carpenter ants that most likely live among the logs above water. At the other extreme, I often use a size 20 Fur Ant to fool trout that I find making intermittent sipping rises in the slow-moving water of larger pools. For general searching in the absence of rises—and for fishing wet—I’ll use a size 16. In all cases, you should dead-drift the fly to simulate how trout encounter any of the natural ones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One special—and also potentially frustrating—ant situation usually happens in summertime: Vast flights of winged ants sometimes appear—often the day after a rainstorm—and accidentally fall on trout streams, quickly covering the surface with thousands of dead and dying insects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trout go crazy over these fallen swarms. But because the natural bugs are all identical in size and color, the trout also become extremely selective. You must have the right size (usually 14 to 20) and color (usually black) parachute ant pattern in your fly box. Without it, you may as well sit there and just watch all the rising trout.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t21"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t22"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Forget everything you’ve heard about dry-fly fishing with grasshopper patterns—all that crazy stuff about so-called hopper plagues or how monster browns will smash these things like largemouths hammering a bass bug. Chances are, it’s not going to happen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead, you’ll see selective brown trout gently, almost imperceptibly, sipping a small hopper dry as it dead-drifts along a bank. On heavily fished rivers, such as Montana’s Madison or Yellowstone, many flyfishermen cast hopper patterns all day—and the fish have wised up. Yes, there are still rare times and places when a size 8 high-floating hopper will draw a heart-stopping rise. More often, though, you’ll do much better by carefully fishing a smaller, lower-floating pattern such as a Henry’s Fork Hopper in size 12 or 14.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, forget the hopper-and-dropper combination that is so popular these days. The addition of a small, trailing nymph behind your hopper dry can make things worse instead of better. You’ll be trying to cast and dead-drift your little hopper tight to the edges of stream-bank cover where the trout are; if there’s a trailing nymph extending beyond the hopper, it will likely hook and tangle on that cover as the flies land.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally—and this pertains to all terrestrial fishing—at the end of the day, you’ll need to chill out. No, I don’t mean relax. I mean quit fishing terrestrials. As the sun goes down and the air cools, terrestrials naturally become less active and less available to trout. Switch to a caddis dry, or maybe a streamer fly, and your hot-streak day will continue into evening.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p28.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t23"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Small nymphs and dry flies don’t hold on to much water, but large streamers—especially those tied with rabbit strips or marabou—act like sponges. A meaty streamer dunked on Saturday will still be soggy the next weekend if you left it sealed up in your fly box, and will leave condensation that gets the rest of your flies damp. Given that you use flies in the water it seems counterintuitive, but moisture is the enemy. Prolonged wetness can actually cause the materials to rot and stink. It can also cause feathers and synthetic fibers to get matted, hindering them from wiggling the way they should the next time you fish the flies. At the end of a day of streamer fishing, I always leave my box open in the garage or on the deck overnight to let air circulate around the bugs for proper drying.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_border"
  }, [_c('a', {
    attrs: {
      "id": "t23"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p28a.jpg"
    }
  })])]), _c('div', {
    staticClass: "boxa"
  }, [_c('a', {
    attrs: {
      "id": "t23"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "t23"
    }
  }), _c('a', {
    attrs: {
      "id": "e3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIAL FLIES: HARE’S EAR")])])]), _c('a', {
    attrs: {
      "id": "e3"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYPE:")]), _vm._v(" Nymph")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIMARY SPECIES:")]), _vm._v(" Trout")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Available in many colors and sizes, the Hare’s Ear is a go-to nymph when you’re just not sure what to go to. It can represent almost anything small—a stonefly emerger, an emerging caddis, a tiny crayfish—based on how you fish it. If you’re not seeing any surface activity on a trout stream, and streamers just aren’t turning fish, it’s hard to go wrong bouncing a Hare’s Ear across the bottom on a weighted rig, or swinging it just below the surface unweighted. It’s almost guaranteed to match some aquatic larvae present in the river that the trout want to eat. As a loose rule, I like black Hare’s Ears in stained water, and tan or olive in clear water.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "e3"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p29.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Over the last few years, flyfishing for pike and muskies has become very en vogue. And why not? These species are big and mean, and when they explode on a streamer, it can stop your heart. Thing is, pike and muskies have lots of teeth, so you can’t just tie on a big fly and start casting with traditional leaders, unless, of course, you’re really into losing flies. Before you set out for toothy targets, consider adding these tools to your arsenal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BITE TIPPET")]), _vm._v(" A bite tippet is critical for thwarting pike and muskie chompers. You can buy a cheap pack of pre-tied steel leaders at the sporting goods store, but I don’t recommend it. These leaders are designed for use with hard lures and bait hooks in saltwater, where the species being targeted don’t often require much finesse. They’re very stiff, and a fly needs to move seductively and naturally in the water. Tie-able steel leader, such as Cortland’s Toothy Critter Tie-able, is soft, and you can knot it to the end of your main leader with a simple Albright knot. It’s also very limp, so your flies will maintain their action. Try losing the steel leader all together and using a piece of 80-pound fluorocarbon if you’re dealing with extra-finicky pike and muskies. It’s invisible underwater, and their teeth won’t cut through it most of the time.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("JAW SPREADERS")]), _vm._v(" Pike and muskies have a bad habit crushing a fly so hard that they literally inhale it into the back of their throat. Problem is, these fish are also notorious for not unclenching their jaws, even after they’re in the net. A set of jaw spreaders shouldn’t set you back more than $15, and they’re one of the best investments you can make. This simple tool will keep the mouth pried open wide so you can control the fish with one hand and remove the hook with the other hand, using long pliers. Not only will a jaw spreader make life easier and save your fingers, it’ll help ensure more fish swim away healthy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HOOK SHARPENER")]), _vm._v(" In most flyfishing scenarios you’ll probably never take the time to sharpen a hook, and that’s okay because you’ll probably never regret that decision. But that’s not the case in the pike and muskie game. Their mouths are very bony, making it more difficult than you might think to stick the hook in their jaw. Your best offense against those rock-hard mouths is a razor-sharp hook. Even if you’re not catching any fish, check the hook frequently. It only takes one bump of a log to dull a point, and, considering you might only get one shot at a muskie all day, you don’t want to blow it because you were too lazy to quickly run a sharpening file over the hook.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t25"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Trout feeding patterns change when temperatures drop and insect life cycles slow down, so you’ll have to alter your tactics a bit. One of these three approaches should coax a few fish from their icy lies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SMALL & SLIM")]), _vm._v(" On most winter trout streams, tiny mosquito-like midges are the most active and available food form. Standard midge pupa patterns—such as Brassies and Serendipities—can be effective. So can slim-bodied nymphs, such as the Flashback Pheasant Tail. But size is often more important than the specific fly. Think small, and go for patterns in sizes 18 to 22 on 5X to 7X tippets.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p30.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HIGH & DRY")]), _vm._v(" Rising fish are a bonus rather than a mainstay of winter fishing, but it’s worth it to be prepared. A size 18 or 20 Parachute Adams or Parachute Black Gnat, or a Griffith’s Gnat in sizes 18 to 22, will cover the occasional hatch of midges or, on some rivers, bluewing olive mayflies. Low, clear winter water can make rising fish ultracautious. Keep a low profile and use long, fine leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p30b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BIG & GAUDY")]), _vm._v(" If the microflies aren’t bringing them in, you might try the other extreme—big leeches and streamers down to size 4 or so. I hooked my largest winter trout on an ordinary No. 8 black woolly bugger. Fish near the bottom, and dead-drift with short twitches.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p30c.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t25"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t26"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("To restore mashed flies to their original operating condition, all you need to do is boil water. Just put a teakettle on, and crank up the heat to produce a healthy jet of steam. Grip the fly you need to revive at the hook bend with a pair of pliers and hold it in the vapor stream, rotating slowly so that the mist pene­trates the fly’s wings, tails, and hackles. Heat and moisture will relax the kinks, massage out the crimps, and return the fly to fishable shape. As soon as it looks refreshed, shake off excess moisture and lay it on a paper towel to dry.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p30d.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t26"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t27"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If the river stains in winter, open your fly box and reach for a Meth Egg. Slowly drift the pattern under a strike indicator through areas of soft current, or high-stick it with plenty of lead in the fast runs that steelhead use to make their way upriver. This flashy material reflects even low amounts of sunlight and gets chromers hyper.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t28"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tiny midge and mayfly patterns give you great results when used in the fall and winter months, but putting one of these flies on a strand of tippet can be a serious nightmare, especially with cold fingers after a cup of coffee or two. Of course, before you can even tie one on, you’ve got to remove one of these micros from your fly box. Drop it, and there’s a good chance you won’t find it again. To help get the frustration out of the midge game, try this trick from legendary Wisconsin fly tyer John Gribb. His “midge matchbook” does away with the need for tweezers to extract a fly from your box, and makes tying a midge on your line a cinch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 1")]), _vm._v(" Slice a sheet of foam with scissors to create a series of matchstick-sized sections.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 2")]), _vm._v(" Staple the foam to a tab of cardboard or heavy card-stock paper.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 3")]), _vm._v(" Stick the midge (or small mayfly, caddis, or other) flies to the ends of your “matches” to protect the flies when you fold the cardboard like a matchbook and tuck the tab under the stapled end. This packet easily fits in your shirt pocket, vest, or pack.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 4")]), _vm._v(" When you’re ready to fish, thread the tippet through the eye with the fly still on the foam (you can either tear off the individual tab, or twist the whole booklet to help you tie your knot). Then simply detach the fly from the foam and maybe add a dab of floatant— and you are good to go.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t29"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your local river may be frigid, but if you can get to (or live in) one of the warmer coastal areas from South Carolina to Florida to Texas, winter offers some of the year’s best shots at skinny-water redfish that are quick to eat a crab. When temps dip, these crustaceans can be more abundant than shrimp, but the trick to hooking up is picking the right one. Here’s why you should give Simon’s Hover Crab a shot.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RIPPLE EFFECT")]), _vm._v(" Fish this fly on a mono leader dressed with a smear of floatant, and you can swim the crab right across the surface. Make the tasty morsel ripple and wake, and any redfish looking up to feed will crush it with the same conviction as a summer largemouth smashing a foam popper.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HOVER CRAFT")]), _vm._v(" Lightly belly weighted and created with foam, Simon’s HoverCrab is designed to suspend in the strike zone. This makes it a deadly choice when reds are rooting in weeds or submerged grass that is too thick for a dumbbell-weighted fly. Get this pattern hovering just above the grass tops with sink help from a fluorocarbon leader, and get ready for the slurp.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t30"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you plan to wade in a cold winter trout stream, you’ll want to opt for boot-foot neoprene waders with boots that are a half size to a full size larger than you normally wear. The bigger the boot, the more dead air space inside; by giving your feet extra wiggle room, you’ll keep blood flowing to your toes all day. The extra space also means your foot is farther away from the thick rubber material that’s making direct contact with the water. Stocking-foot waders worn with wading shoes allow the icy water to surround your feet, and when that happens, even the best wool or battery-operated socks will offer little long-term defense against the chill.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t30"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t31"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A lot of really expensive wading boots seem to come with absolutely lousy laces. We’re talking $200 boots with laces that break after being soaked in a river four or five times. That, to me, is plain cheap and stupid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve worn fancy boots from all over, and they all claim to be the next best thing. Some of them fit great and grip great on the bottom of the river, but after a few trips, when I go to tie them, the laces break. Do yourself a favor. Don’t trust any of the mainstream boot companies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh sure, go find a pair that fit you just so, have a good tread and all of that. But if those boots don’t come with a set of wire laces, go ahead and punt the laces that they come with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead, go to the nearest sporting goods store, buy some hockey skate laces, and swap those in. Ice hockey skates see plenty of moisture and wear and tear. While not perfect, their laces are far better than the cheap import stuff that comes standard on most wading boots.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p34.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t32"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Compared with the drabness of many trout patterns, flies for bass are a carnival freak show come to life. Garish colors and outlandish names, such as Meat Whistle and Chubby Gummy, highlight the bass fishing midway these days, where high-tech glitter promises plenty of low-tech fun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The essence of flyfishing for bass is a kind of laid-back antidote to trout fishing’s match-the-hatch intensity. Bass bugs are fanciful rather than factual, full of wanton wiggles as they pop, slide, or slither among the lily pads of summer. New materials and tying techniques are making bass flies more diverse and more effective than ever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poppers and sliders are both essential patterns for topwater fishing. The styles are classic, but modern bodies of painted, dense foam float better and last longer than the cork versions. Soft silicone-rubber legs, meanwhile, add lifelike movement that drives bass nuts. Cup-faced poppers like the Ump­qua Bass Popper make lots of surface noise when twitched, thereby stirring up lethargic fish. As much fun as poppers are to fish, I often use a subtler floating slider, such as Murray’s Shenandoah Sunfish Slider. Sliders make a slow and quiet surface wake when stripped with intermittent pauses. Perhaps imitating a wounded bluegill, sliders are the answer for pressured bass in clear water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Newer developments in trout flies also have some application in bass fishing, notably various popular and large foam-bodied dries. Patterns like Mercer’s Flush Floater Stone work as well for smallmouth bass as for trout—or even better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not all modern bass bugs are high floating. Polk’s Dirty Rat swims with only its nose above water when retrieved—just like a mouse. Then there’s Chocklett’s Chubby Gummy Minnow, a fly-casting version of the soft-plastic jerkbaits used by conventional bass anglers. Its soft, reflective body is a great imitation of the threadfin shad that are common forage in many lakes.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p35i.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t33"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Looking to fool big largemouths? Sure, hair bugs are classics, but these new-school patterns must find a home in your arsenal. Whether you’re looking for blow-ups in the lily pads, or have to dredge a bass off a deep rock pile, these ties have you covered.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p35j.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t33"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t34"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fly anglers are now imitating bass lures, and the results can be terrific. Barr’s Meat Whistle, and the Gulley Ultra Craw from Orvis, are similar to skirted bass jigs, but with a key difference: They have even more fish-appealing wiggle—thanks to the combination of flexible furs and feathers and comparatively little weight. They’re heavy enough to sink, but won’t rocket to the bottom. Because bass often hit while the fly is sinking, a slow drop is a good thing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are equivalents for soft-plastic worms, too. The Hare Jig is based on a long, flexible strip of wiggly rabbit fur. That soft fur has more bass-­tempting wiggle than even the softest of plastics. The fly also has a lightly weighted head to give a jiglike action when retrieved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rabbit-fur flies do raise one critical point: Fur soaks up water, and the weight can become very difficult to cast with lighter gear. Although lighter bugs can easily be cast with trout tackle, bigger flies require a heavier line and rod. Eight- to 10-weight rods are not too big for larger bugs, and they’re best coupled with a bass-taper fly line. Heavy rods may seem intimidating, but the latest graphite models, like the Bass series from Sage, feel quite light and do a superlative job of casting big bugs 40 to 50 feet away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is not dainty stuff. When a 6-pound bass smashes your bug, those heavier rods have enough power to keep the fish from diving back into cover. So not only will you have awesome surface strikes, you might land the fish, too.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p36a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t35"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why weigh yourself down when all you want to do is blitz a local creek for a few hours? Flyfishermen have a nasty habit of carrying too much gear when, in reality, quick jaunts require very little. A neck lanyard, like the Neckvest Lanyard 5 from Loon Outdoors, is a great option for a “get in, hook a few, and get out” trip. The trick is making sure you have exactly what you need. Load your lanyard with these tools, and you’re all set.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sa.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("FORCEPS")]), _vm._v(" Clip them anywhere on your lanyard and forget about them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sb.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("NIPPERS")]), _vm._v(" If your lanyard doesn’t come with this handy tool, buy an inexpensive pair that always stays with your neck gear.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sc.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("FLOATANT")]), _vm._v(" Necessary for that whole critical “keeping your dry flies on the surface” thing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sd.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("TOP FLIES")]), _vm._v(" You should really hope to have a bead on your specific local hatches, but if not, a few Adams, buggers, caddis, and hare’s ears should have you well covered.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/se.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("TIPPET")]), _vm._v(" Don’t worry so much about carrying extra leaders. Just bring a spool of tippet in the size you’ll use most.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p37.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t36"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Strike Indicator tool was developed in New Zealand (famous for its fickle trophy trout). It’s pretty simple: Small tubing pieces are threaded on a tool that grabs the leader like a crochet hook. Pull the leader, slide the tube in place, and form a loop through which you place chunks of colored wool. Then cinch the loop tight, and the wool stays put—you can slide it up and down the leader on a whim. You choose how much wool forms the indicator, depending on the currents you’re fishing. You can use orange-dyed wool, but I like white—it looks like the bubbles on the water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To me, the wool is the real attraction. We like wool sweaters and socks because they wick water. In the case of this indicator, a dab will do. It rides high, but sinks quick on the tug, so it’s super-responsive. Casting-wise, it cleanly slices through the air and lands on the surface with barely a splat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, you can shape the wool. I like to make it stand up in a tapered “flame” shape. That post stands straight up when the weight and flies drop into the zone. Any hitch or bobble prompts me to set the hook. When the flies are grabbed hard, it plunges. Don’t lean on the indicator as the end-all, be-all solution for catching trout with flies. But if you’re going the strike indicator route—and most of us do, sooner or later—this option is worth a look.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p37a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t36"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t37"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A black Sharpie is a permanent fixture in my trout pack. It has been ever since I traveled to western Colorado last year and caught a 32-inch rainbow—the biggest trout of my life. After a solid morning with streamers and dries, my guide had me switch to a tan hopper for the afternoon. But before I tied the fly on, he colored the body black with a Sharpie he kept in his vest, explaining that when fish see the same pattern over and over, a little change can make a big difference. Sure enough, the fish hammered the black bug, and I caught my best trout ever. And that was enough to convince me to carry a Sharpie from then on.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p37b.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t37"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t38"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Not all bass flies come with integral weedguards, but it’s easy to add your own. One trick involves stretching a small rubber band between the hook eye and the barb. The rubber band deflects weeds as you retrieve but pops free when a bass grabs your fly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In some cases, you’ll be better off using a weedguard made for crappie jigs by Southern Pro Tackle (shown below). The soft-plastic device has a small eyelet that slips over the hook eye before you tie a bug to your leader. A slim cylinder trails the eyelet; stick the end over your hook point. This commercial weedguard might be too small for some larger hook sizes, but once you get the idea, it’s very simple to make larger versions. All you need is sharp scissors and a soft-plastic worm.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p38.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t39"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("While we can debate whether fly colors really matter all that much compared to other factors such as size, profile, and so forth, I don’t think it hurts to add a little eye-grabbing detail, particularly when you’re fishing attractor patterns, and especially when you plan to be fishing nymphs in deeper runs when the water is off-color. As a rule of thumb, it’s best to mimic natural bugs as closely as possible when you know fish are keyed on a specific food source. But when you’re prospecting, any and all “attention-getters” are worth a shot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spectrum Response UV spray is designed to make all of the colors pop on your flies. Squirt it on a surface, such as fur or feathers, and it will cause any of those materials to absorb radiation in the ultraviolet range of the electromagnetic spectrum, and then emit that radiation as light. In simplest terms, it makes flies appear brighter when the water is darker. The theory is pretty simple: Fish sees fly better; fish is more apt to eat said fly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The spray is nontoxic and hydrophobic, meaning it doesn’t wash off of treated surfaces (so you want to be careful not to spray your tippet if you don’t want that to shine). It doesn’t involve resins that will gum up your flies. One tube of spray goes a long way; it only takes a squirt or two to treat a fly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’re looking for a bit of an advantage but you’re not willing to go so far as to scent your flies (that would be a low-down dirty trick, after all), this bottle might be $20 well spent.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p38a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t39"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t40"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Other than the usual stuff, here are four key items to carry in your flyfishing vest.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BINOCULARS")]), _vm._v(" I use my Swarovski 8x20s to better see what the trout are doing, not to mention for spying on the other guys.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IBUPROFEN")]), _vm._v(" The best antidote for long sessions of casting and stripping heavy flies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SAFETY PINS")]), _vm._v(" Fix your wader suspenders, make an emergency line guide or tip-top guide, untangle knots, or clear the eye of a hook. Pinned to your vest, this is the ultimate inexpensive field tool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHEAP STOGIES")]), _vm._v(" Perfect for sitting on the stream bank waiting for rises; also repels insects and other nosy anglers.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t41"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you can find a videocassette case—maybe at a flea market or yard sale—it’s easy to turn it into a cheap fly box.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Line the case with foam weatherproofing tape, which works well because it’s already cut to the perfect size and the adhesive backing makes it easy to install. This box is packed with 109 flies, and ridiculously easy to carry in any vest or pack. For a bonus, find an old box for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jaws.")]), _vm._v(" Or maybe "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A River Runs Through It")]), _vm._v(". How about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Fly")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39b.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t41"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t42"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unlike Bob Dylan, fishermen do need a weatherman to know which way the wind blows. A small portable radio designed to receive NOAA weather forecasts should be an essential part of your fishing gear. Mine lives in the glove box of my truck, along with spare batteries. If I’m wade fishing, I listen to the latest forecast while suiting up streamside. When I head out in a boat, I take my radio along and tune in periodically. Aside from the obvious safety advantage, the short-term wind forecasts allow me to pick a protected river bend or stretch of canyon, or to find the lee and windward shores of a lake. If this technology seems archaic, you’ll thank me when you’re in a remote spot where your cell phone is worthless but the radio is still getting a signal.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_border"
  }, [_c('a', {
    attrs: {
      "id": "t42"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39a.jpg"
    }
  })])]), _c('div', {
    staticClass: "boxa"
  }, [_c('a', {
    attrs: {
      "id": "t42"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "t42"
    }
  }), _c('a', {
    attrs: {
      "id": "e4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIAL FLIES: STIMULATOR")])])]), _c('a', {
    attrs: {
      "id": "e4"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYPE:")]), _vm._v(" Dry Fly")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIMARY SPECIES:")]), _vm._v(" Trout, Bass")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A stimulator is designed to do exactly what its name suggests; stimulate a fish into rising. A favorite pattern on Western waters where fish tend to be looking up even without a major hatch occurring, this fly simply gives trout a large target that looks like a juicy meal. While the “stimmy” may not represent anything specific, it is a perfect match for certain large bugs such as salmon flies and grasshoppers. As stimulators are very buoyant, they are ideal for fishing in tandem with a heavier nymph riding below, or as a marker fly ahead of a smaller dry that’s not as easy to see. Though stimulators are mostly associated with trout, I’ve caught many fine smallmouth bass drifting them in summer on East Coast rivers.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "e4"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t43"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Waxed cotton is a great option for waterproof clothing, but the coating eventually wears thin. Here’s how to rewax that old-school wading jacket without spending big bucks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 1")]), _vm._v(" Warm up your garment in the sun, on a heater, or, if you’re vigilant, in an oven. It’s easier to wax warm cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 2")]), _vm._v(" Create a handy applicator by cutting a 10x15-inch piece from an old T-shirt, folding it in half lengthwise, and rolling it up. Tie it off with a string so it doesn’t unravel. It’s easy to hold, covers a large area if you lay it down flat, and gets into tight spots if you hold it upright.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40a-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 3")]), _vm._v(" Heat water in a pan and add the can of wax to melt it. If the molten wax starts to solidify while you are using it, reheat it in the pan until it’s easy to work with again.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40a-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 4")]), _vm._v(" Apply the wax to your garment’s exterior, but judiciously. Resist the temptation to just slather it on, even if you haven’t waxed your gear in a while. Lighter, regular applications are best. Cotton can only absorb so much wax, and the excess stays on the surface, gunking up anything it comes into contact with.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40a-4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 5")]), _vm._v(" When you’re finished with the rewaxing process, you’ll want to either hang the garment in the sun or place it over a radiator or furnace (and keep an eye on it). For extra credit, you can warm it with a blow-dryer. This will really help draw the wax into the cotton.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40a-5.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t43"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t44"
    }
  }, [_c('div', {
    staticClass: "box_border"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PATCH KIT MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Small pouch or zip-seal bag for storage Aquaseal • Cotol-240 • Alcohol swabs Coffee stirrers • Nylon stockings • Craft knife Latex gloves • Athletic tape • Wader patches")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Don’t let a leaky boot be the end of your day. Canvas, rubber, or breathable waders usually require 24 hours to repair, but toss this emergency patch kit in your vest and you’ll be back on the water after lunch. Note that this fix won’t allow moisture to escape—but will a square inch of nonbreathable material kill you?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, clean the area around the hole with an alcohol swab, then tape the tear closed from the inside of your waders. Cut a patch from the nylons big enough to cover the hole. Mix 1 part Cotol-240 accelerator with 3 to 4 parts Aquaseal using a coffee stirrer or brush (this speeds up the glue’s drying time). Spread the mixture around the tear, extending the glue ⅓ inch beyond the patch size. Place the patch in the mixture and lay it flat over the tear. Finally, apply a light coat of Aquaseal on top, and lay the waders flat to dry for one hour.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p41.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t45"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I fall, I fall hard, so you won’t find me wading a rocky river without spike-sole boots. Goat Head Sole Spikes have saved my hide on some seriously snot-slick rivers. These ¼-inch cold-forged, heat-hardened steel spikes, which have 28 biting edges per head and a serrated base to stop them from backing out, install easily in soles with or without pre-drilled holes.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t45"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t46"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gore-Tex is a common material for waders and rain gear because it’ll keep you dry without becoming clammy… until you poke a hole in it. Here’s a simple trick to find all those pesky pinhole leaks. Simply turn the waders, jacket, or rain pants inside out and spray the garment with rubbing alcohol. Any spot with a hole will darken when the alcohol is applied. Dab the dark spot with sealant, and you’re back to dry.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p41a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t46"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t47"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You may find that hooking your gravel guards onto the end of your wading-boot laces will result in torn laces after a while. To solve this problem, cut a couple of thick rubber bands crosswise from a bicycle inner tube (they’re stronger than regular rubber bands). Loop the bands around the first wrap of the bootlaces and hook the gravel guards into them instead. This saves your shoelaces, and gives flexibility as you bend and move.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p41b.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t47"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t48"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You don’t see a lot of innovation in shoelaces, but the Boa closure system for wading boots counts for sure. Boa laces are wire and they crank tight by turning a knob at the top of the boot. Pull the knob, the wire loosens, and you step right out of the boot. If you ski or snowboard, you’re familiar with the idea. But are these laces a good idea? It’s usually a matter of personal preference. Some people swear by the Boa system, and some hate it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The biggest problem with this system is that there’s no bailout or quick fix if it breaks when you’re on the river. You can’t splice the wire and most anglers don’t carry a repair kit. So if you’re three miles into the back country, or if you’re in the middle of a river float, and that thing gives way, you basically have a flat tire you can’t fix. For that reason, I would never hike-in fish with Boa boots and I would never make Boa boots my dedicated pair for taking on a long trip, especially to somewhere like Alaska.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having said that, they are comfortable and convenient. I like being able to immediately loosen them and kick my boots off at the end of a long day, especially when the weather is cold enough to make laces icy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you have a place where you normally fish that’s not too far off the beaten path, and you don’t like bending over and lacing up your boots. (Some people have flexibility issues.) I say go for it. Boa is great, especially if you don’t go fishing very many times per year. If you’re whacking out 100 river days a year or more, if you hike a lot or travel a lot, and especially if you are hard on your gear, I’d suggest you take a pass.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p42.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p43.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t49"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unlike a spinning or conventional outfit, where the reel and weight of the lure or bait you’re using dictate how far or how accurately you can cast, when it comes to flyfishing, things are a bit different. The reel won’t help you gain distance, and what’s tied to the end of the line makes no difference. What you’re actually casting is the line, and the weight of the fly you choose simply makes it more or less difficult to cast that line properly. Different styles of water, proper presentation of certain styles of fly, and the pursuit of different species of fish sometimes call for specialty fly lines. These are the four most commonly used, and picking the right one will up your success with the long rod.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sa.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("FLOATING LINE")]), _vm._v(" The vast majority of flyfishing situations call for a fully floating line. Whether you’re presenting dry flies on a trout stream or bass bugs on a lake, floating lines cast the easiest and most accurately. Even if you need to fish a wet fly or nymph below the surface, most fly anglers aren’t fishing areas deeper than 6 feet or so, or are targeting fish holding higher in the water column. The 7- to 12-foot leader you’d use with a floating line is typically long enough to allow your flies to reach the proper depth. Floating line also acts as its own strike indicator; when swinging a fly below the surface, keep an eye on the point where the fly line meets the water and watch for ticks and stops. It’s important to occasionally treat floating lines with dressing to keep them supple and slick for good castability. If they crack or lose their coating, they may not float as well. You can also find specialty floating lines that perform best in warm or cold water.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sb.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("SINK-TIP LINE")]), _vm._v(" Sink-tip lines offer the ease of casting of a full-floating line, but with the addition of a 5- to 12-foot tip section that sinks. They are popular with anglers who lean heavily on streamers that have to be stripped back to mimic baitfish in the water. You can also use a sink-tip line to fish nymphs and wet flies in deeper rivers and lakes. A sink-tip line is ideal for water in the 5- to 10-foot depth range, but you can also use it to increase your success in shallower water when you need to get a fly in the zone quickly. As an example, if you are floating in a drift boat and want to strip your streamer through a deep pocket, that fly may take longer to sink if you fish it on a floating line, and by the time it reaches the proper depth, you might only get a strip or two in the zone. A sink-tip line will let the fly sink into the same pocket fast, thus giving your fly maximum time in the strike zone when you only have a few seconds to make your presentation.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "t49"
    }
  }), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sc.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("INTERMEDIATE LINE")]), _vm._v(" Often clear or light colored, intermediate line is heavier than floating line, but as you’d imagine from the name, lighter than a full-sink line. This weight is designed to sink slowly, allowing you to present flies to fish holding in the middle of the water column. The coloring helps this line blend into the surroundings underwater. Saltwater flyfishermen use it for chasing wary species like striped bass; It’s also used by freshwater anglers who strip streamers in clear lakes and deeper rivers for everything from trout to smallmouth bass to muskies. Though you can use an intermediate line to present trout flies in streams, one disadvantage is that it’s harder to see the line in the water, which can make detecting subtle strikes tricky. Intermediate lines shine when the target species is going to crush a fly that you are stripping, as opposed to gently nipping a fly that’s drifting in the current.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sd.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("FULL-SINK LINE")]), _vm._v(" Though it’s not very fun to cast, full-sink line exists for special situations and for the anglers who like to push the limits of flyfishing. In saltwater, a full-sink line might be in order to get a fly down 20 feet or more in a hurry to a school of bluefin tuna. In freshwater, anglers use full-sink lines to get streamers to the deepest, darkest holes in lakes and rivers, where monster trout and bass live. Sinking lines are generally configured by grain, which translates to weight, thus telling you how many feet or inches per second the line will sink. One drawback to a full-sink line is that it has no versatility, so, while one hole in the river may call for it, you’ll likely be hanging flies in the rocks all day in areas of shallower depths. But if you think there is a huge pike on the bottom in 25 feet of water at your favorite lake and you insist on catching it on the fly, a full-sink might be the only way to get a streamer in front of its face.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t50"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Leaders are among the basic elements of fly tackle, but the essentials of leader design and performance get the least attention from most anglers. Modern knotless leaders are designed for the law of averages: average casters casting average-size flies to an average distance. But most fly anglers constantly change fly sizes and casting distances, so no leader is perfect all the time. When your fly is landing off target, or you can’t get a drag-free drift, don’t automatically blame your casting—it could be your leader.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TWEAK THE TIPPET")]), _vm._v(" If your dry fly is falling back on the leader when you make a presentation, shorten the tippet by a foot, use a tippet one size larger, or both. This is often a problem when you’re switching from a small dry fly to one that is larger and less aerodynamic. The same remedy will also help you punch a dry fly into the wind. If you can’t get a drag-free drift, on the other hand, lengthen your tippet by 1 or 2 feet, which will create a bit of slack leader near the fly when it lands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Changing a tippet section takes just a few minutes on the water. Granted, it’s another thing to keep track of while you’re fishing, but paying attention to those sorts of details will definitely catch you more fish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GET A HEAVY REAR END")]), _vm._v(" In both bass and saltwater fishing, where I will be using larger lines and flies, I solve most leader problems by using a heavier butt section with 9-weight lines and above. That might mean about 3 feet of 50-pound mono (.030 inch diameter) at the end of the fly line, to which I attach a knotless, tapered leader after cutting a couple of feet off the leader’s smaller-diameter butt. The added mass helps extend heavier flies at the end of the cast.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_border"
  }, [_c('a', {
    attrs: {
      "id": "t50"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44.jpg"
    }
  })])]), _c('div', {
    staticClass: "boxa"
  }, [_c('a', {
    attrs: {
      "id": "t50"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "t50"
    }
  }), _c('a', {
    attrs: {
      "id": "e5"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIAL FLIES: COPPER JOHN")])])]), _c('a', {
    attrs: {
      "id": "e5"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYPE:")]), _vm._v(" Nymph")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIMARY SPECIES:")]), _vm._v(" Trout")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Introduced by legendary fly tyer John Barr in 1996, this nymph has a reputation of scoring trout when nothing else will. Part of its magic stems from its weight. The combination of a lead-wrapped core, wire-wrapped body, and bead head get the fly down faster than nymphs of similar size. Though you can find Copper Johns tied with many different body colors, the traditional copper is hailed as the most effective. It’s neutral, so it matches a wide variety of aquatic insects, yet it provides some eye-catching flash. The Flashabou wing case coated in epoxy also allows the fly to glint like a natural aquatic insect as it rides the current.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "e5"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t51"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Knotless leaders of nylon monofilament are a common sight these days, but the basic taper designs are the same as ever. The flyfishing pioneer and French hotelier Charles Ritz worked out the basic 60-20-20 leader formula in the early days of mono after World War II. By his design, 60 percent of a leader’s length is a level, large-diameter butt; 20 percent is a steeply tapered transition; and the last 20 percent is a fine-diameter tippet to which his fly is tied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leader-butt diameter should be two-thirds the diameter of the end of the fly line for best performance. The 5-weight fly line you may use for fishing small dry flies has a tip diameter of about .030 inch. The 9-foot, 6X leader you attach to it should then have a butt diameter of about .020 inch. Most light trout leaders conform to that standard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Problems may occur when you start switching line, leader, or fly sizes. The leader taper that works for small dry flies on a 5-weight won’t work for big steelhead dries on an 8-weight, and vice versa. The tip diameter of an 8-weight floating line is about .040 inch, which requires a larger .026-inch-diameter leader butt to get the leader to turn a large fly over properly in casting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You don’t need a micrometer in your vest to keep track of all the numbers, because many manufacturers label their packaging with both the butt and tippet diameters. Some companies even distinguish their leaders by species, such as trout or bass. In this case, trout should mean a small-butt, small-fly leader; and bass, the opposite.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t51"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t52"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Moving from a shallow riffle to a deep pool will sometimes mean switching from a floating line to a sink-tip line. This will involve changing your spool, restringing, and rerigging—a ­time-gobbling task, especially when fish are rising. Avoid the hassle and get up and running in seconds by using an interchangeable sink-tip. Here’s how to make one.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 1")]), _vm._v(" Cut a piece of running line from an old sinking line. A good rule of thumb is 5 feet for shallow water, 10 feet for middle depths, and 15 feet for deep water. Vary the length for individual streams or current speeds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 2")]), _vm._v(" Take a braided loop and work the Chinese finger-lock over the line as far as it will go. Slide a piece of the included tubing over the braid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 3")]), _vm._v(" Apply a drop of instant glue to seal the deal [A].")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 4")]), _vm._v(" Use a loop-to-loop connection to attach the sink tip to the fly line, and then the leader to the sink tip [B].")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p46.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t53"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can use stripping baskets when wading in deep or rough water to prevent loose line from getting tangled at your feet or blowing in the wind. But stripping baskets are a hassle to travel with. Luckily, if you’re ever in a pinch, making one isn’t that difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 1")]), _vm._v(" Head to the local watering hole. If you’re vacationing somewhere tropical that doesn’t have a bar (if that’s even possible), find the closest grocery store.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 2")]), _vm._v(" Ask the bartender for an empty case from bottled beer (or a full case that you’ll empty later). Tip the mixologist a dollar or two and find the local hardware store.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 3")]), _vm._v(" Shop for yarn, string, or rope by the foot. You’ll need 10 feet max to do the trick. Remember, this will be hanging around your neck for a decent period of time. Make sure the material is wide and soft enough that it won’t rub your skin raw. If you can’t find a hardware store, use the thickest piece of monofilament in your gear bag and apply a length of tape where it contacts your neck.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 4")]), _vm._v(" Punch a hole 3 inches from the top on both sides of the box. Attach the string so that the box comes to your waist. If you want to get fancy, hit up the closest restaurant and ask for two large egg trays. Cut to size and thrown in the bottom of the case, they make cone spacers that help keep the line snarl-free.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_border"
  }, [_c('a', {
    attrs: {
      "id": "t53"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p46a.jpg"
    }
  })])]), _c('div', {
    staticClass: "boxa"
  }, [_c('a', {
    attrs: {
      "id": "t53"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "t53"
    }
  }), _c('a', {
    attrs: {
      "id": "e6"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIAL FLIES: ELK HAIR CADDIS")])])]), _c('a', {
    attrs: {
      "id": "e6"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYPE:")]), _vm._v(" Dry Fly")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIMARY SPECIES:")]), _vm._v(" Trout")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There are few trout streams in the world that don’t experience a caddis hatch at some point during the season. Although these insects vary in color, a simple elk hair caddis with a neutral tan or cream underbelly will match most hatches anywhere in the world. Elk hair does the best job of capturing the elongated wing profile of a live caddis, and also allows the flies to float very high on the surface, barely making a dimple, just like the real deal. This extra-buoyant material is tough to sink when dressed properly, which makes it easier for the angler to “skate” or “skitter” the fly, mimicking the action of a real caddis hopping and dancing across the water’s surface.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "e6"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t54"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The problem? A rat’s nest of floating, sinking, and intermediate fly lines in various weights. Wind them on reels for storage, and line memory sets in, setting you up for coil-snared casts in spring. Dump them in a shoebox, and they end up as tangled as Medusa’s tresses on a bad hair day. The solution? A permanent marker and an old duck mount. Trust me.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 1")]), _vm._v(" Clean each line by soaking in warm water with a few drops of mild dish soap. Pull the line through a clean cloth, and apply fly-line dressing. Let the lines dry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 2")]), _vm._v(" Mark each butt end. Using Lefty Kreh’s smart system, make one long dash to represent a 5-weight. Add or subtract dots in front or behind to delineate line weight. (For example, a dot in front of the long dash means 1 subtracted from 5, branding the line as a 4-weight.) Use different colors for various tapers and sink rates.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 3")]), _vm._v(" Coil each line in long loops and hang the loops from your duck (or a board studded with nails). My ancient canvasback holds eight lines. Hang the duck in a cool, dry place away from direct sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47b.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t54"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t55"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If I know I won’t be flyfishing for a straight month or so, I store my flyline by wrapping the first 40 feet around a large coffee can. The diameter of the can prevents tight curls from forming in the line, which helps it lie straight on the water the next time you go fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p48.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t56"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A fly reel has three purposes: to store line and backing, to provide a smooth drag against running fish, and to balance your rod’s weight and leverage. Even the most complex flyfishing reels are simpler than an average spinning reel, but it still behooves you to understand and utilize this vital gear. Flyfishing reels don’t revolve during a cast, since fly anglers strip line from the reel and let it pay out during the back-and-forth motion called “false casting.” In the past, fly reels have served largely as line-storage devices with simple mechanical drags. Advancing technology and an increase in flyfishing for big, strong-fighting fish have led to strong drag systems that can stop fish as large as tarpon. Other recent developments include warp- and corrosion-resistant materials and larger arbors (the spindles around which the line is wrapped) that reduce coils and help maintain consistent drag pressure.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FRAME")]), _vm._v(" Holds the spool. A weak frame will warp, causing friction as the spool revolves.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DRAG KNOB")]), _vm._v(" Adjusts drag tension. Some smaller reels have click-pawl drags, while reels for larger fish sport strong cork and composite disc braking systems.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SPOOL")]), _vm._v(" Many reels are fitted with removable spools. Having different fly lines ready on a number of spools allows an angler to switch tactics more quickly.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ARBOR")]), _vm._v(" The spindle around which the fly line is wrapped. Many modern reels have larger arbors that help recover line quickly when a fish swims toward the angler.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ARBOR")]), _vm._v(" The spindle around which the fly line is wrapped. Many modern reels have larger arbors that help recover line quickly when a fish swims toward the angler.")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49b.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t57"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A spinning reel that costs $30 is going to mechanically function the same as one that costs $1,000. The expensive reel may have a stronger drag system and be constructed of better quality components, but in the end, the inner workings aren’t much different from the budget model. This, however, isn’t the case with fly reels, so if you’re in the market for a new one, understanding the advantages and disadvantages to the two most common styles of internal gears can help you determine how much to spend and which reel is best for you. It ultimately boils down to what species of fish you intend to hook, and how hard that fish is going to fight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sa.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("CLICK-PAWL DRAG")]), _vm._v(" In the early days of flyfishing, all reels featured a click-pawl drag. In a simple setup, a gear fixed to the back side of the spool locks into triangle-shaped clickers held in place with tension on the inside of the reel frame. When the spool turns, the clickers keep up tension to stop the line from overrunning, and also prevent the spool from moving in reverse. Some click-pawl reels feature adjustment knobs that allow the angler to change the amount of pressure on the clickers, thus making it easier to reduce tension when stripping line off to cast, and making it easier to increase tension when a fish is pulling against the reel. Click-pawl drags are still popular today, but they are mostly found on inexpensive reels. Click-pawls are also typically reserved for chasing smaller fish, such as stream trout and pond bass. Species such as these aren’t likely to peel all the line off the reel and get into the backing, and that’s important because a click-pawl isn’t designed to handle smoking runs from big, fast fish. In fact, most of the time while trout or bass fishing, the fish won’t pull much line at all, and the angler often does not even use the reel to retrieve the catch. That said, it doesn’t make much sense to spend a ton of money on a click pawl for small-water applications, as the reel is little more than a line holder.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/sb.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("DISC DRAG")]), _vm._v(" Disc-drag reels use a series of stacked washers sandwiched between plates covered in materials such as cork or carbon-fiber that can be compressed or decompressed via a drag adjustment knob to increase or decrease tension. Disc-drag systems factor in the amount of heat generated when a fish is spinning the drag quickly, as well as the torque applied during a hard run. They can cost a pretty penny depending on the materials, but if you’re chasing salmon, steelhead, striped bass, or tuna that are going to take a lot of line, you’ll definitely want reliability. Many are also sealed within the reel frame by a metal housing (particularly important if you’re exposed to saltwater) to thwart corrosion and ensure moisture doesn’t damage the system.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_border"
  }, [_c('a', {
    attrs: {
      "id": "t57"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49.jpg"
    }
  })])]), _c('div', {
    staticClass: "boxa"
  }, [_c('a', {
    attrs: {
      "id": "t57"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "t57"
    }
  }), _c('a', {
    attrs: {
      "id": "e7"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIAL FLIES: FLASHBACK PHEASANT TAIL")])])]), _c('a', {
    attrs: {
      "id": "e7"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYPE:")]), _vm._v(" Nymph")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIMARY SPECIES:")]), _vm._v(" Trout")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Another generic imitator of a wide range of aquatic insects, the pheasant tail might be tiny, but it packs a wallop. Most anglers don’t fish this nymph solo, instead incorporating it into a double nymph rig aimed at giving trout a choice of meal sizes. The flashback version of this fly actually makes a great add-on to almost any rig, as it doesn’t increase the overall weight. Drifting a dry fly? Hang a flashback pheasant tail under it. Stripping a streamer? Get a flashback in tow. Working in this little bonus fly certainly never hurts, and quite often, the wee flashy morsel gets eaten faster than the main course.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "e7"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t58"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A rod’s cork handles deteriorate with use. After repeated soakings and dryings, the cork will weaken and chip, creating holes. If these holes are left untreated, then the surrounding cork grows even weaker and may break. This quick patch job will extend the life of your grip.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SAND")]), _vm._v(" Take a clean, dry wine cork and sand it with 220- to 240-grit sandpaper to make a fine cork dust. You will need to collect about ½ teaspoon to fill a 1-centimeter hole.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GLUE")]), _vm._v(" Mix the powder with wood glue. Add sufficient adhesive to create a smooth and dry consistency, like that of cookie dough. Your patching material should not be fluid, or it’ll run out of the holes and gaps.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PATCH")]), _vm._v(" Use a sharp, pointed tool to clean out pitted areas. Fill them with your patch material. The filler will shrink when it dries, so you must repeat the process to get the holes flush with the good parts of your grip.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SEAL")]), _vm._v(" When the filler has dried, buff with 220-grit sandpaper, wash with water and mild soap, and dry. Seal the cork with gunstock finish or a splash of cork seal.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t58"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t59"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you’ve ever wandered from a main river into a small feeder stream, you’ve probably wished for a shorter rod. A couple of predrilled wine corks stowed in your vest will help you build your own short stick on the spot. Simply separate the tip from the rest of your rod; usually about 2 to 4 feet of length is all you need. Place the butt section that holds the reel in your wading belt, and pull out about 20 feet of line. Slide the corks onto the butt of the tip section to create a new handle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 1")]), _vm._v(" Measure the diameter of the female ferrule and select an appropriate drill bit. A ¼-inch bit should cover most tip sections.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 2")]), _vm._v(" Put one end of the cork in a vise and position the drill bit at its center on the opposite end.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 3")]), _vm._v(" Use the fastest speed possible to avoid tearing the cork wall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 4")]), _vm._v(" As the drill nears the end of the cork, stop and remove the cork from the vise. Hold it in your hand and carefully finish drilling. (Other­wise the vise’s pressure would break the cork.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 5")]), _vm._v(" Before use, soak the corks in river water. This softens them enough to fit over the ferrule.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p51.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t60"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A broken guide shouldn’t be the end of a perfectly fine rod or a great fishing trip. For strength, speed, and durability, nothing beats a strip of shrink-wrap to attach a new guide. In the fall, local marinas or boatyards have scraps from winterizing that you can pick up for free, and you can buy an assortment of guides at local fly shops. Make a repair kit and keep it in your truck. You won’t win a beauty competition with this fix, but you’ll still catch fish when the bite is on.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 1")]), _vm._v(" Cut a triangular piece of shrink-wrap long enough to wrap three times around your rod. The width of the triangle’s base should extend beyond the foot of the guide.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 2")]), _vm._v(" Cut off the threads and foot of the broken guide with a razor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 3")]), _vm._v(" Select an appropriately sized replacement.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 4")]), _vm._v(" Tape the new guide to the rod blank.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 5")]), _vm._v(" Wrap one foot with shrink-wrap.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 6")]), _vm._v(" Heat with a hair dryer. For this step, you’ll need electricity, so swing by a gas station or 24-hour mart. They’ll usually let you plug into an outlet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEP 7")]), _vm._v(" Repeat on the second guide foot.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t60"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t61"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The one thing I can’t stand about winter is ice forming in the guides of my rod. Luckily, there’s a cheap, simple fix: Just spray some nonstick cooking spray on those guides before you head out. Don’t gunk it on, and wipe away the excess. You can give the smaller guides at the end of the rod an extra shot right before you string up. I know other anglers who like to use things like WD-40, but I prefer a slightly less “industrial” solution, and PAM seems to work pretty well. It will last a good couple hours or so, depending on how cold the air is. Besides, if the fishing is really slow and you use olive oil cooking spray, you can always chew on your line and pretend it’s spaghetti.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_border"
  }, [_c('a', {
    attrs: {
      "id": "t61"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p51a.jpg"
    }
  })])]), _c('div', {
    staticClass: "boxa"
  }, [_c('a', {
    attrs: {
      "id": "t61"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "t61"
    }
  }), _c('a', {
    attrs: {
      "id": "e8"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIAL FLIES: BLUE WINGED OLIVE")])])]), _c('a', {
    attrs: {
      "id": "e8"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYPE:")]), _vm._v(" Dry Fly")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIMARY SPECIES:")]), _vm._v(" Trout")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Often labeled “BWOs” in fly shops, this pattern represents one of the most prolific and long-running hatches from coast to coast. Olives are mayflies that can start hatching as early as February in some parts of the country, and can last well into late fall. With that in mind, BWOs are often the first dry flies anglers tie on in the beginning of the season, and the last before winter sets it. When nothing else is hatching, you can count on seeing a few olives drifting down stream. When there is a major hatch of bigger bugs, you can bank some olives still in the mix. The trout’s’ willingness to eat these flies depends on what other food is available, but hitting any given river without some BWOs in your box will bite you sooner or later.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t62"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many trout anglers start out with 9-foot 5-weight graphite rod, which is a great choice. However, if you’re considering a beginning lighter rod, say 3-weight or less, you should seriously consider fiberglass over graphite. Here’s why.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SENSATION")]), _vm._v(" That classic slow action of a fiberglass rod really helps you feel your casts. You sense the rod loading and unloading the line, which will help you develop a good stroke. And that’s exactly what all anglers should work on, especially beginners.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ACTION")]), _vm._v(" When are you really going to boom out big casts in the small-stream environment? Better to have a rod with which you can roll cast, mend, and pop short casts at small target zones, rather than a super fast action rod that you won’t really use to full capacity. Sometimes the super-fast modern graphites are about as functional in light rods as a V-8 engine would be on a riding mower. Fiberglass gives you feel and all the casting oomph you practically need for most in-close fishing environments.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COST")]), _vm._v(" Lastly, fiberglass can be much more affordable. You don’t have to spend several hundred dollars to find a perfectly fun and functional fly rod.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Here are some solid options.")]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("RODS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LOW COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cabela’s CGT rods")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MODERATE COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Redington Butter Stick")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HIGHER COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Orvis Superfine")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HIGH COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scott F2")])]), _vm._v(" "), _c('div', {
    staticClass: "box-black"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "colw"
  }, [_vm._v("NOTES")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LOW COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Probably the best value-priced option out there.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MODERATE COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of the darlings of the fiberglass world right now, with good reason.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HIGHER COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some nicer “made in America” components and construction, and very consistent action.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HIGH COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-org"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("These rods still offer a full flex, but a faster recovery than many others. And they’re heirloom quality.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t62"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t63"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the exception of the thick, wide first guide—known as the stripping guide—fly rods are built with light, thin-wire guides, often called “snake guides.” Since the reel never comes into play in terms of cast distance or accuracy, snake guides are designed to simply let the fly line pass through freely and without obstruction while adding as little weight to the rod as possible. To that end, it’s important to always make sure snake guides are aligned properly and don’t have any grit or residue buildup on the inside. You want the guides to remain as smooth as possible to maximize your casting distance and accuracy. The stripping guide is wider and beefier because it takes the most strain when stripping streamer flies. You’ll often find two stripping guides on heavier fly rods used for saltwater fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p53a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t64"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Even today, in the age of graphite, many fishermen yearn to cast finely crafted rods handmade of superior cane blanks, silken wraps, and high-grade cork. The rods have a romantic history, but they’re also practical; many feel they deliver a small dry or emerger better at 10 to 40 feet than the best graphite rod.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quality new rods run $1,000 to $4,000, while used ones range from a few hundred dollars to many thousands. Beware of the deal that sounds too good to be true. Some rods listed in the $500 range are made from blanks built in China and may have flaws. Others might come off an assembly line. If it isn’t built by hand, the quality will not be there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps the most important criterion when you’re choosing a new or used bamboo fly rod is feel. Bamboo rods are made in a variety of tapers, and they all load more slowly than their graphite counterparts. Some anglers like this action; others don’t. Always cast it before committing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Really check the rod out before you buy. Make sure it’s straight, not bent. Look for shoddy glue seams where water may get into the bamboo. Examine the ferrules to make sure they aren’t oxidized, pitted, or warped. If you pick up a rod that looks good and casts well and you like it, buy it.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_border"
  }, [_c('a', {
    attrs: {
      "id": "t64"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p53b.jpg"
    }
  })])]), _c('div', {
    staticClass: "boxa"
  }, [_c('a', {
    attrs: {
      "id": "t64"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "t64"
    }
  }), _c('a', {
    attrs: {
      "id": "e9"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIAL FLIES: PRINCE NYMPH")])])]), _c('a', {
    attrs: {
      "id": "e9"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TYPE:")]), _vm._v(" Nymph")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIMARY SPECIES:")]), _vm._v(" Trout")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Developed in California in the 1930s by Doug Prince, there’s no question that this nymph is a true classic fish-catching machine. While the Prince is technically a stonefly imitation designed for fishing in fast water, anglers have learned in all the decades since the pattern’s inception that it will catch trout anywhere, any season, in any kind of water. The combination of shimmering peacock herl body, gold tinsel ribbing, and sharp white wings give the fly a distinct profile and contrast underwater. Regardless of clarity and water speed, trout just seem to be able to pick it out. No matter where I’m trout fishing, if the situation calls for me to use nymphs, I usually tie on a Prince first.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "e9"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p54.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t65"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Developed in Japan about 200 years ago, tenkara fishing was introduced to American anglers in 2009. This method uses a very long fly rod with no reel; the line is tied directly to the tip. By using a truncated style of short-distance casting, anglers can use these rods to reach across any conflicting currents and prevent a faster (or slower) current from pulling the fly and causing drag. Adherents nearly worship tenkara, which they say emphasizes skill more than gear.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RODS")]), _vm._v(" Tenkara rods telescope, and some can extend to nearly 15 feet. With a base length of less than 2 feet, they’re great for packing into tight headwaters. “Use the longest rod you can,” says Daniel Galhardo, owner of Tenkara USA. The limiting factor is how much canopy might impede the cast, not overall length. “You’ll quickly get used to the length, and you’ll want the line control.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LINES")]), _vm._v(" These are about the length of the rod and attach to the rod’s tip. There are two broad types: More traditional tapered lines which afford a super-delicate presentation, and newer level lines which are more easily altered on the stream but are harder to cast. Lines are tipped with a short 3- to 4-foot tippet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FLIES")]), _vm._v(" Most tenkara flies feature a reverse hackle in which the feather is brushed forward toward the hook eye. This gives the fly a pulsing profile.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p54a.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t66"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You don’t need an expensive rod case for travel. In fact, that might entice thieves with its promise of a pricey rod within. This simple trick allows you to stash your rod safely in your checked luggage. Cut a piece of 4-inch-diameter PVC pipe long enough to fit the broken-down rod and still fit inside your suitcase. Break the rod down, wrap it in newspaper, and stash it in the pipe. Nestle it into your suitcase, and travel safely and discreetly.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t66"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t67"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wiggling a rod won’t tell you much about its action and feel, so walk into the store with a reel loaded with your favorite line, with leader attached, and a few flies with the hook points snipped off. Ask if you can try a few casts in the parking lot, on a nearby lawn, or off the loading dock out back. If you ask really nicely, they’ll let you.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p56.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t68"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Too many of us make the mistake of stowing dirty fly gear in winter. Don’t be lazy. Take an hour or so when the season ends to properly winterize your tackle. Those rods, reels, lines, waders, and flies you spent good money on will last longer if you store them clean and dry. And you’ll be better prepared to hit the water when the spring hatches turn on.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FLY LINE")]), _vm._v(" If you leave a gritty, gunky fly line wrapped tight on a reel for months, it’s almost certain not to float properly next time on the water. Clean it with warm water and mild dish soap. Pull the line through a wet paper towel or cloth, feeling for major nicks and abrasions. If you do find some, it’s time to toss that line and buy a new spool. Otherwise, store it on a wire coat hanger by bending the “elbows” of the hanger to create two notches. Loosely tie the end of the line to one notch, and then wrap it lengthwise around the hanger. This minimizes memory and will ensure that the line fully dries. Label each hanger with the line type. In spring, as you respool the line, pull it back through a pad or towel treated with fly-line conditioner.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GORE-TEX WADERS")]), _vm._v(" Hose down the outside of your Gore-Tex waders, and hang them overnight to air-dry. Once they are dry, turn them inside out. Dab rubbing alcohol, which shows up leaks better than water, on any suspicious areas to examine them for pinholes and abrasions. Smear some Aquaseal on the holes, and let it set. Store waders on a rack or a coat hanger, in a dry, cool place. Don’t wad them up. Don’t put them back in the box they came in. And don’t store them in the garage if your temperatures drop well below freezing or fluctuate significantly in winter months.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("REELS")]), _vm._v(" Use a mixture of water and mild soap, and an old soft-bristle toothbrush, to clean away grime. Pop the spool and remove any grit. (I suggest removing the backing; wrap it around an old coffee can for the winter.) Rinse the reel and towel-dry it. Leave the spool and case apart overnight to air-dry. Sparingly lube the reel, and then reassemble and stow the reel in its case.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RODS")]), _vm._v(" Wipe the surface grit off of your rod, let it air-dry, and then pack it in its sleeve and tube for the winter. For rods that don’t break down, clean the cork handles with mild soap and water, and stand them upright (handles down) against a wall in a place that won’t get too hot or too cold. If that means your basement, stand them on a plastic bucket as a base to guard against any damage from moisture.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FLIES")]), _vm._v(" Organize your flies in a large plastic compartment box or bin. Put three dry paper towels inside the box’s lid to wick moisture from the flies. You can also get silica gel packs at a camera store to place in the box for added moisture protection.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VEST OR CHEST PACK")]), _vm._v(" Leave it unzipped, and drop a silica gel pack in a couple of the compartments to dry it out over the winter. Hang in a cool, dry closet.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p57.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "t69"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I get many questions about how best to pack fishing gear for a flight. After thousands of miles and having gear broken and/or lost, I’ve come up with these five tips.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "t69"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHECK YOUR RODS")]), _vm._v(" Airlines are so inconsistent about how they handle rods as carry-on (no matter what they tell you up front) that I recommend always checking them—inside tubes, inside your luggage ")]), _c('a', {
    attrs: {
      "href": "#/cap01#t66"
    }
  }, [_vm._v("(see item)")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("KEEP IT TIDY")]), _vm._v(" Assume that the TSA is going to go through your stuff. Don’t leave items such as pliers or fly boxes laying loose; keep them in your pack, or in your vest in your luggage, or put them in plastic bags and pack them.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GO LIGHT")]), _vm._v(" Assume you will be 5 pounds heavier coming back than when you leave. If you want to avoid excess baggage fees, don’t pack your outbound bag right at the 49-pound limit. When your stuff gets wet, it gets heavier. I always pack at 45 pounds or less on my way to go fish.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DRESS LIGHT")]), _vm._v(" For the same reason, I usually travel with light, crushable rain jackets, and sometimes even lighter waders or boots. I’ll trade an extra layer of Gore-Tex for a few pounds, unless I’m going to a place where I know it’ll be raining the whole time. Check the weight of boots before you buy—an extra pound or two won’t matter as much in the river as it will at the airline counter.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DON’T TEMPT THE TSA")]), _vm._v(" Check your flies, pliers, and knives with your luggage. Don’t even try to carry on flies. You’re asking for extra inspection, and if the hooks are large enough, TSA agents will confiscate them.")])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-833b135e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap01.vue
// module id = 72
// module chunks = 0